// Translations.js
const translations = {
    en: {
        accountreportcenter: ' ACCOUNT & REPORTS CENTER',
        PDF: "PDF",
        viewdetails: ' View Details',
        addnewvehicale: ' Add a new vehicle to your asset list.',
        cancelandstay: 'Cancel and stay on the page',
        confirmandlogout: 'Confirm and logout',
        welcome: 'Welcome',
        welcomeback: 'Welcome Back',
        editandudateasset: ' Edit and update asset details ',
        assigntheselected: 'Assign the selected assets to the field staff',
        updatetherule: ' Update the rule',
        submitherule: ' Submit the rule',
        addassignmentrule: ' Add assignment rule',
        savetherule: ' Save the rule',
        addcompletionrule: ' Add completion rule',
        addcustomrule: ' Add custom rule',
        assignallactiverules: 'Assign all active rules',
        addnewspecialassingmentrule: ' Add new special assignment rule',
        updatetherulewitjselectedpara: ' Update the rule with selected parameters',
        createneweulwwithselected: ' Create new rule with selected parameters',
        cancelandclose: ' Cancel and close dialog box',
        addnewdashboardtooltip: ' Add a new dashboard (You can create the dashboard based on workflow)',
        processthenextstep: ' Process the next step',
        deletethedashboard: ' Delete the dashboard',
        createdashboardtooltip: ' Create a dashboard ',
        canceltheselectedchart: 'Create  the selected chart',
        applytheselecteddaterange: 'Apply the selected date range filter',
        downloadfilterdate: ' Download with filtered date',
        proceedwiththeaction: ' Proceed with the action',
        addnewproject: ' Add new project',
        addnewdepartment: ' Add new department',
        addneworgnization: ' Add new organization',
        updateorgnizations: ' Update organizations',
        savethechangesmadetomarkers: ' Save the changes made to the marker colors',
        updatethechangesmade: ' Update the changes made to the marker colors',
        cancelanddiscardchanges: ' Cancel and discard changes',
        requestthereport: ' Request the report',
        savetheprotectedaccount: ' Save the protected account',
        submitthereportrequest: ' Submit the report request',
        cancelandgoback: ' Cancel and go back',
        exportthexcelfilebasedon: ' Export the excel file based on the filter',
        createaprotectedaccountwithpermanent: ' Create a protected account with permanent protection or for specified duration',
        downloadthereportfortheselecte: ' Download the report for the selected date range',
        uploadtheinventorysheet: ' Upload the inventory Excel sheet',
        downloadincentoryreport: 'Download the inventory report',
        applythesleectedfilters: 'Apply the selected filters ',
        uploadtheselectedexcelfile: 'Upload the selected Excel file',
        createinstallmentplan: ' Create installment plan',
        generatepreviewfiter: '(Generate preview first)',
        emiamount: '(EMI amounts do not match the outstanding amount)',
        finisheditinisntall: ' (Finish editing installment) ',
        savechangesbeforesubmiting: ' (Save changes before submitting )',
        totalemaiamount: '(Total EMI amount cannot be negative)',
        userscancreateup: '(Users can create up to 6 installments only)',
        printpreviewtable: 'Print preview table',
        generatepreview: 'Generate preview',
        clearpreviewdata: ' Clear preview data',
        submitforRccreation: ' Submit for RC creation',
        savethechagesmadeto: ' Save the changes made to the payment amount',
        editthepaymentamount: ' Edit the payment amount',
        submitspecialRc: ' Submit special RC',
        printinstallmentdetails: ' Print installment details',
        proceedwithdeleaction: 'Proceed with delete action',
        deletetheselectedtask: ' Delete the selected task',
        unassignntheseledtask: ' Unassign the selected tasks',
        reassigntheselectedtask: ' Reassign the selected tasks',
        assigntheselectedtask: ' Assign the selected tasks',
        multiselecte: 'Muti-select',
        addemailenablrnotifi: 'Add emails, enable notifications, and configure other settings',
        donwloadthetaskrecordin: 'Download the task record in Excel based on the selected activity or for all activities',
        createtaskbulk: 'Create a new task, create and assign, or perform a bulk task upload',
        uploadthetasksheet: 'Upload the task sheet',
        assingtaskbasedonselectedrules: 'Assign tasks based on selected rules',
        reassigningprocess: 'Reassigning in progress',
        reassingselectedtasktochosen: 'Reassign selected tasks to chosen field agents',
        assingtaskbasedonselectedrule: 'Assign tasks based on selected rules',
        reassinginginprocess: 'Reassigning in progress',
        reassignselectedtasktochosenfield: 'Reassign selected tasks to chosen field agents',
        unassignselectedassingeesfromtask: 'Unassign selected assignees from tasks',
        savetheupdateddatacompleted: 'Save the updated data for completed tasks',
        gobacktheprivious: 'Go back to the previous screen without saving',
        resetthecompletiondata: 'Reset the task completion data',
        closewithoutsavingchnages: 'Close without saving changes',
        savechangesmadetothefield: 'Save changes made to the field',
        viewworkflowguidlines: 'View workflow guidelines',
        createnewworkflows: 'Create a new workflow',
        selectorgtocreateaworkflow: 'Select an organization to create a workflow',
        scheduleemail: 'Schedule email',
        exporttheexcelfilebasedonfilters: 'Export the Excel file based on filters',
        exportpdfbasedonfilters: 'Export the PDF file based on filters',
        downloadpdfbasedonfilters: 'Download PDF based on filters',
        savechangesforprofile: 'Save changes for profile',
        requestonewreport: 'Request a new report',
        createamanualtask: 'Create a manual task',
        createandassingtasktofield: 'Create and assign a task to a field agent',
        closethedialogbox: 'Close the dialog box',
        gobacktomapmandotoryfield: 'Go back to map mandatory fields',
        submitmappeddataandstartupload: 'Submit the mapped data and start the upload',
        procestomapnonmdaotry: 'Proceed to map non-mandatory fields',
        gobacktotaskpriority: 'Go back to task priority selection',
        proceestomapmadatory: 'Proceed to map mandatory fields',
        gobackprivousscren: 'Go back to the previous screen without saving',
        addmultipleaccount: 'Add multiple account numbers and assign tasks to field agents',
        selectatleast: 'Select at least one field agent to assign',
        assingmentinprocess: 'Assignment in progress',
        assingselectedtasktochosen: 'Assign selected tasks to chosen field agents',
        recallassingedtask: 'Recall assigned tasks from users',
        deleterecordfrom: 'Delete records from the uploaded file',
        donwloastheuplodedexcel: 'Download the uploaded Excel file',
        uploasthexcelfile: 'Upload the Excel file for the selected activity',
        savethechanges: 'Save the changes',
        diacardchanges: 'Discard the changes',
        proceedtomapnonmdfield: 'Proceed to map non-mandatory fields',
        submitthemapedcol: 'Submit the mapped columns and upload the data',
        uploadtheslectedfile: 'Upload the selected file',
        uploadtheaccountexcel: 'Upload the accounts Excel sheet to the master database',
        clearalldata: 'Clear all data',
        fetchtheaccounthistory: 'Fetch the account history for the entered account number',
        donwlaodthetaskreportinpdfformat: 'Download the task report in PDF format',
        editandupdateuserdetail: 'Edit and update user details',
        saveandcreateuser: 'Save and create user',
        donotsavechangesgoback: 'Don’t save changes and go back',
        addauserassingroles: 'Add a user and assign roles or privileges',
        previewcurrentworkflowlayout: 'Preview the current workflow layout and fields',
        submitworkflow: 'Submit the workflow',
        pleaseselectatleastonefild: 'Please select at least one field as a report',
        plzmakesuretosetauique: 'Please make sure to set a unique workflow name before cloning',
        updatetheworkflowiwth: 'Update the workflow with the latest changes',
        addnewvalidation: 'Add a new validation',
        closewithoutsavingchanges: 'Close without saving changes',
        viewwxistinfcalidation: 'View existing validations',
        savechangesmadetovalidation: 'Save changes made to validations',
        discarchangesandexit: 'Discard changes and exit',
        savetheupdateddata: 'Save the updated data for completed tasks',
        addselectefield: 'Add selected fields to the report',
        gotonextpage: 'Go to the next page',
        gotopreviouspage: 'Go to the previous page',
        refeshreportlist: 'Refresh report list',
        gobackpreviouspage: 'Go back to the previous page',
        requestreporbasedonfilter: 'Request report based on filters',
        filteredReports: 'Filtered Reports',


        failedtoloadruledata: ' Failed to load rule data.Please contact help@blufield.net',
        pleaseSelectLeastAssetBeforeAssigning:
            "Please select at least one asset before assigning.",
        plzselectfieldagent: 'Please select field agent',
        assetsucassigned: 'Assets were assigned successfully.',
        assetsfailedassigned: 'Failed to assign assets',
        logout: 'Logged out successfully',
        rulecreated: 'Rule created successfully.',
        unexpectederroroccured: 'Error submitting the form. Please contact blufield support at help@blufield.net ',
        plzselworkflow: 'Please select a workflow before adding criteria.',
        ruledeleted: 'Rule deleted successfully.',
        failedelrule: 'Failed to delete the rule.',
        PleaseSelectWorkflowBeforeAddingRule:
            "Please select a workflow before adding a rule.",
        plzfillallfield: 'Please fill in all mandatory fields to submit.',
        failtoloadasign: 'Failed to load assignment rules. Please contact help@blufield.net',
        failedtoassign: 'Failed to assign all rules. Please contact help@blufield.net .',
        OnClickTheOldAssignmentRuleDisabled:
            "When clicked, the previous assignment rule will be disabled.",
        invalideruleid: 'Invalid rule ID.',
        plzselfield: "Please select a field agent.",
        nopermission: 'You don’t have the necessary permissions to view this page.Please contact help@blufield.net ',
        plzselectorg: 'Please select an organization.',
        somthingwentwrong: 'Something went wrong!. Please contact help@blufield.net',
        excelisdownloading: 'The Excel file is downloading…',
        norecordfound: 'No records found.',
        anerroroccurred: 'An error occurred while downloading the report. Please contact help@blufield.net',
        orgaddedsuc: 'Organization added successfully.',
        errorcreatingorg: 'Error creating organization. Please contact help@blufield.net',
        failstofetchorg: 'Failed to fetch organization data.',
        orgupdated: 'Organization updated successfully.',
        allfieldarerequired: 'All fields are required.',
        reportreqsuc: 'Report requested successfully.',
        errorequestreport: 'Error requesting report.',
        addremark: 'Add a remark!',
        protectedAcccreated: 'Protected account created .',
        protectedAccUpdated: 'Protected account updated.',
        errorcreatingprotacc: 'Error creating protected account.',
        pleaseSelectOrganizationCreatingAccount:
            "Please select an organization before creating an account.",
        pleaseSelectProjectIdFirst: "Please select a project first.",
        norecordareavailbles: 'No records are available.',
        downloadlinkmissing: 'The download link is missing.',
        invalidresponse: 'Invalid response format.',
        failedFetchReports: "Failed to fetch reports.",
        reportgeneratedsuccc: 'Report generated successfully!',
        pleaseSelectRecordProceed: "Please select a record to proceed!",
        errorOccurredWhileDeletingRecord:
            "An error occurred while deleting the record.",
        failedtofetchmeter: 'Failed to fetch meter inventory details.',
        userStatusupdatesuc: 'User status updated successfully.',
        failedtoupdateuserstatus: 'Failed to update user status.',
        fileuploadedsucc: 'File uploaded successfully.',
        failedtouploadfiles: 'Failed to upload the file. Please contact help@blufield.net',
        pleasegeneratepreview: 'Please generate the preview before creating the installment.',
        failedtogeneratepdf: 'Failed to generate the PDF. Please try again or contact us at help@blufield.net',
        installmentupdated: 'Installment plan updated successfully!',
        installmentplancretsuc: 'Installment Plan Created Successfully!',
        errorgeneratingpdf: 'Error generating the PDF or submitting the installment plan!',
        failedtoconnectserver: 'Failed to connect to the server. Please try again.',
        youcannotpaythefullamount: 'You cannot pay the full amount in one installment. Please distribute it across all installments.',
        eachinstallmentmusthave: 'Each installment must have at least the minimum amount.',
        changesavedsuc: 'Changes saved successfully!',
        plzwentervalidacc: 'Please enter a valid account number.',
        fieldagentassinged: 'Field agent assigned.',
        NoasssingData: "No assignee data available",
        unAssignTaskSuccessMeg: "Your request has been received and is being processed in the background. You’ll be notified once it’s complete.",
        pleaseselect: "Select a workflow first.",
        plzenteracommentbeforedel: 'Please enter a comment before deleting the task.',
        taskdelsuccessfully: 'Task deleted successfully.',
        erroccureduringtask: 'An error occurred during the task.',
        failedtoassignbyarea: 'Failed to assign tasks by area.',
        plzselectactivity: 'Please select an activity.',
        noassigneselectedfor: 'No assignees selected for unassigning.',
        delteallrecord: 'All records have been deleted.',
        taskprioriyupdated: 'Task priority updated.',
        pdfnotavailable: 'PDF is not available.',
        datafetchedsuccessfully: 'Data fetched successfully.',
        anerroroccuredtaskhistory: 'An error occurred while fetching the task history.',
        taskupdatedcussfully: 'Task Updated Successfully.',
        erroruploadingfileplztry: 'Error uploading the file. Please try again or contact us at help@blufield.net ',
        orgismissingnotdrag: 'Organization ID is missing, cannot drag!',
        nochangwsmadetothe: 'No changes were made to the field type.',
        selectOrgWarning: "Select organization first.",
        pleaseselectdayreport: 'Please select the day for the report.',
        reportprocesucc: 'Report processed successfully!',
        nofileselc: 'No file selected.',
        filesizeexceeds: 'File size exceeds 5MB.',
        invalidfiletypeplimg: 'Invalid file type. Please upload an image',
        invalidfiletypedouc: 'Invalid file type. Please upload a document',
        unsupportedfile: 'Unsupported file type.',
        plzfillallfieldbeforeadd: 'Please fill in all fields before adding asset.',
        assetaddedscucceffuly: 'Asset Added Successfully.',
        fillFieldbeforeAddVehical:
            "Please fill in all fields before adding a vehicle.",
        assetupdatedsuc: 'Asset updated successfully.',
        vehicalupdatedsuc: 'Vehicle updated successfully',
        emailidorpass: 'Email or password is incorrect.',
        loginConnectionError:
            'Unable to connect to the server. Check your internet connection and try again.',
        loginFailed: 'Unable to sign in. Please try again.',
        accessdenied: 'Access Denied !',
        otpverifiedsuc: 'OTP verified successfully.',
        failedtoverifyotp: 'Failed to verify OTP.',
        noworkflowinorg: 'No workflows are available for this organization.',
        plzuploadpdffileonly: 'Please upload PDF or video files only.',
        guidlineuplodsucc: 'Guideline uploaded successfully.',
        invalidfiletype: 'Invalid file type. Please upload a JPG, PNG, or GIF',
        emailnotavailble: 'Email not available. Please ensure your profile is loaded',
        youcanotmodify: 'You cannot modify the existing password unless cleared first',
        youcanowenter: 'You can now enter a new password',
        passowrdmust: 'Password must be at least 8 characters,include an uppercase letter,lowercase letter,number,and special character',
        profileupdated: 'Profile Updated',
        failedtofetchemails: 'Failed to fetch emails',
        enteremailfirst: 'Enter your email first, then you can enable email notifications.',
        statusupdatedsucc: 'Status updated successfully.',
        failedtoupdatednotifcation: 'Failed to update notification setting',
        errorfiledownloaded: 'Error: File Downloaded',
        fileuploadedaborteddue: 'File upload aborted due to an error.',
        plxselectanoption: 'Please select an option.',
        pleasefillallmandtoryfield: 'Please fill in all mandatory fields to proceed.',
        uploadcanceled: 'Upload canceled',
        nodatavailvle: 'No data available',
        nofieldavailable: 'No fields available.',
        categoriyaddedsucc: 'Category added successfully.',
        plzselectdeltype: 'Please select a deletion type.',
        failedtodelfile: 'Failed to delete the file.',
        uploadedtasksheet: 'The uploaded task sheet list is shown in the table!',
        nomoredatatoload: 'No more data to load.',
        taskdetailupdatedsuc: 'Task details updated successfully!',
        norecordavbforthisacc: 'No record available for this account number, please try another account number',
        userupdatedsuc: 'User updated successfully',
        usercreatedSuc: 'User created successfully',
        failedtofetchusers: 'Failed to fetch users.',
        nofieldabuplodtasksheet: 'No fields available, Upload task sheet first to get additional fields',
        nomoreuniqueversion: 'No more unique versions available',
        nomoreversionavailble: 'No more versions available ',
        createworkflowdiagram: 'Create Workflow.',
        updatepdfnamefirst: 'Update the pdf name first ',
        pdfnameupdate: 'PDF name updated successfully.',
        updatereportname: 'Update report name first',
        excelnameupdate: 'Excel name updated succssfully ',
        inputvlueadded: 'Input value added!',
        warningthis: 'Warning: This option is already included in the workflow. Removal is restricted',
        fieldremoved: 'Field Removed',
        fieldcloned: 'Field Cloned',
        clonedsuc: 'Cloned Successfully',
        pleaseentername: 'Please enter a name for the cloned workflow.',
        inputfield: 'Input field cannot be empty!',
        warningalready: 'Warning: This option is already included in the workflow. Removal is restricted. You can only edit the name of this option',
        validationremoved: 'Validation removed. Update the workflow for Deletion',
        validationnotapplicable: 'Validation is not applicable for this field type.',
        updatetheworkflow: 'Update the workflow to save these additional fields.',
        failedtoupdatefield: 'Failed to update fields. Please try again.',
        pleaseSelectLeastActivity: "Please select at least one activity.",
        failedSubmitReportRequest: "Failed to submit report request.",
        urlnotprovided: 'URL not provided in the response',
        failedtoaddasset: 'Failed to add asset ',
        vehicleaddedsuc: 'Vehical added successfully',
        failToAddVehical: "Failed to add vehicle.",
        ruleupdatedsuc: 'Rule updated successfully!',
        filesdeleted: 'File deleted',
        plzselectatleatone: 'Please select at least one task to assign',
        plzselectedforilfagrntoasing: 'Please select a field agent to assign tasks',
        invalidworkflow: 'Invalid workflow. Please try again',
        softdeletedsucc: 'Soft delete successful!',
        softdelfailed: 'Soft delete failed!',
        erroduringsoftdel: 'Error during soft delete!',
        permamatdelsuc: 'Permanent delete successful!',
        permantdelfailed: 'Permanent delete failed!',
        errorduringperdel: "Error during permanent delete!",
        taskrecallcompletesuc: 'Task recall completed successfully!',
        taskrecallfailed: 'Task recall failed!',
        erroduringtaskrecall: 'Error during task recall!',
        attachmentismand: 'Attachment is mandatory!',
        onlypdfimgallowed: 'Only PDF and Image files are allowed.',
        workflowmodule: 'The workflow module is not available on mobile devices. Please use a desktop or tablet to continue.',


        Attachment: 'Attachment ',
        viewattachment: 'View Attachment',
        Inactive: 'Inactive ',
        aresurewantodeleterule: 'Are you sure you want to delete Rule?',
        Assigning: 'Assigning ',
        taskcreatesuc: 'Task Created Successfully',
        Requesting: 'Requesting ',
        enterextendeddate: 'Enter Extended Date',
        targetoutstandingamtbyextdate: 'Target Outstanding Amount by Extended Date',
        Comments: 'Comments ',
        No: 'No',
        aresurewanttodeleterecord: 'Are you sure you want to delete record?',
        downladreport: 'Download Report',
        transferto: 'Transfreed To',
        nometerdetailfound: 'No meter details found for barcode',
        Saving: 'Saving ',
        loadingmeterdetail: 'Loading meter detail',
        Print: 'Print ',
        ucantaddmorethan6: `You can't add more than 6 installments`,
        Proceed: 'Proceed ',
        taskdetails: 'Task Details',
        viewexistingfile: 'View Existing File',
        nofileuploaded: 'No file uploaded',
        nooptionavailable: 'No options available',
        fetchingaccdetails: 'Fetching account details',
        workflowid: 'Workflow ID',
        pdflink: 'PDF Link',
        selectefieldpreiview: 'Selected fields for preview',
        fieldname: 'Field Name',
        fieldtype: 'Field Type',
        selectfield: 'Select Field',
        selectinputtype: 'Select Input Type',
        updateinputype: 'Update Input Type',
        uploadnewphoto: 'Upload New Photo',
        Open: 'Open ',
        uploadnewdoc: 'Upload New Document',
        viewpdf: 'View PDF',
        dragandroptoupload: 'Drag and drop to upload',
        aresurewantodeletefile: 'Are sure want to delete file ?',
        generatereport: 'Generate Report ',
        Reject: 'Reject ',
        Approve: 'Approve ',
        loadingmorenotification: 'Loading more notifications',
        nomorenotification: 'No more notifications to load',
        Pending: 'Pending ',
        Task: 'Task ',
        Mandatory: 'Mandatory ',
        Fields: 'Fields ',
        Other: 'Other ',
        Back: 'Back ',
        thisactivitydoesnothavefield: 'This activity does not have fields',
        subcategory: 'Sub Category',
        selectsubcategory: 'Select Sub Category',
        addcategory: 'Add Category +',
        deletetask: 'Delete Tasks',
        dosoftdeletions: 'Do soft deletion',
        depermanatdeletions: 'Do permanent deletion',
        confirmdeletion: 'Confirm Deletion',
        areusurewanttoallassinged: 'Are you sure you want to make all assigned , progress and on-hold tasks active ?',
        selectlocationmap: 'Select Location on Map',
        Loading: 'Loading',
        nowuserfound: 'No users found',
        addfield: 'Add fields',
        updatefield: 'Update Fields',
        enterworkflowname: 'Enter Workflow Name',
        Elements: 'Elements ',
        Report: 'Report ',
        editinputvalues: 'Edit Input Values',
        addedvalidation: 'Added Validations',
        deletefield: 'Delete Field',
        deletevalidation: 'Delete Validation',
        validationcode: 'Validation Code',
        novalidationavailable: 'No validation available',
        rusurewanttodeleteworkflow: 'Are you sure you want to delete this workflow?',
        noversionavb: 'No versions available',
        noreportdataavb: 'No Report Data available',
        goback: 'Go Back →',
        aresurewantodeleteemail: 'Are you sure you want to delete this email?',
        nofieldagentfound: 'No field agents found',
        Selected: 'Selected',
        updatedon: 'Updated on',
        tariff: 'Tariff',
        Office: 'Office',
        cancelupload: 'Cancel Upload',
        Recall: 'Recall ',
        notaskavbtounasign: 'No Task Available to Un-Assign',
        unassigntask: ' Unassign Task',
        selectassigntounassign: 'Select assignees to unassign from the selected tasks',
        allassign: 'All Assignees',
        confirmaction: 'Confirm Action',
        areusure: ' Are you sure you want to delete this task? This action cannot be undone',
        totalcount: 'Total Count',
        Processing: 'Processing',
        currenOs: 'Current OS ',
        updatedat: 'Updated At',
        curros: 'Current Outstanding',
        lastupdateddate: 'Last Updated Date',
        lastupdatedtime: 'Last Updated Time ',
        assingename: 'Assignee Name',
        finisheddate: 'Finished Date',
        fnishedtime: 'Finished Time',
        Unsuccessful: 'Unsuccessful ',
        Success: 'Success ',
        fileprocessingcancle: 'File processing canceled',
        pleaseenteraccnumber: 'Please enter account number ',
        projmissingplzelc: 'Project is missing. Please select a project',
        addleastonelementto: 'Add at least one element to the current page before moving to the next page',
        checkuremailotp: 'Check your email for OTP',
        taskcreatedsuc: 'Tasks Created Successfully',
        taskunassingedsucc: 'Task unassigned successfully!',
        norecordareavailable: 'No Records are Available ',
        failtoupdaterule: 'Failed to update rule',
        startdateerror: 'Start date cannot be after end date',
        anerror: 'An error occurred while assigning assets.',
        errorsubmiting: 'Error submitting form',
        ruleupdated: 'Rule updated successfully',
        failupdaterule: 'Failed to update rule',
        plzselectworkflow: 'Please select workflow before adding rule',
        basicinfo: "Basic Info",
        changeprofile: "Change Profile",
        updateRule: 'Update Rule',
        newRule: 'New Rule',
        assignedAll: 'Assigned All',
        notAssignedAll: 'Not Assigned All',
        LoadingGeo: 'Loading Geo Codes...',
        selectgeocode: 'Select Geo Codes',
        All: 'All',
        loadingtyoecodes: 'Loading Type Codes...',
        selecttypecodes: 'Select Type Codes',
        selectamount: 'Select Amount Range',
        ok: 'Ok',
        addRule: 'Add Rule',
        addproject: 'Add Project',
        departmentname: 'Department Name',
        projectname: 'Project Name',
        adddepartment: 'Add Department',
        seeData: 'See Data',
        enterrecipt: 'Enter recipients, separated by commas',
        enterbcc: 'Enter Bcc, separated by commas',
        entercc: 'Enter Cc, separated by commas',
        assignbyrule: 'Assign by Rules',
        searchfieldAgent: 'Search Field Agents',
        loadingtask: 'Loading task details',
        fieldagentAvgwork: 'Field Agent Avg Work Time',
        selectDash: 'Select Dashboard',
        selecttask: 'Select Task Status',
        selectStatus: 'Select Status',
        SelectDateTime: 'Select Date and Time Range',
        startdatetime: 'Start Date and Time',
        enddatetime: 'End Date and Time',
        selectDateRange: 'Select Date Range',
        fieldAgentCLock: 'Field Agent Clock In/Out',
        selectusertpye: 'Select User Type',
        isClockin: 'Is ClockIn',
        selectvehicle: 'Select Vehicle',
        vehicalid: 'Vehicle Id ',
        OrganizationId: 'Organization Id',
        inuse: 'In Use',
        id: 'ID',
        selectAsset: 'Select Asset ',
        showLatLog: "Show Lat/Long Missing Tasks",
        hidelatlog: "Hide Lat/Long Missing Tasks",
        createdatetime: "Created Date-Time",
        taskCategory: "Task Category",
        mobileno: "Mobile No",
        discardMessage: 'Do you really want to leave? This action will you save or discard',
        viewinstallmentmsg: 'Enter the account number to view installment plans',
        optionalSelectedfield: 'Optional Selection Fields',
        emailnotification: 'Email Notifications',
        recievemeial: 'Receive email notifications for task updates and reminders',
        taskmangement: 'Task Management',
        autoAssignTask: 'Auto Assign Tasks',
        autoasigntaskto: 'Automatically assign tasks to available team members ',
        protectioninWorkflow: 'Protection in Workflow',
        preventtaskprotected: 'Prevent changes to tasks once they are in progress',
        othersetting: 'Other Settings',
        choselang: 'Choose the default language for the application',
        addmeail: 'Add Email',
        email: "Email",
        noFieldsAvailable: 'No Fields Available',
        notchartYet: 'No data available to display for this chart yet.',
        priorityLevel: 'Priority Level',
        entername: "Enter Name",
        Activities: "Activities",
        basicField: "Basic  Fields",
        recent: "Recent",
        selectionfield: "Selection field",
        mediafield: "Media and Special Fields",
        items: "items",
        Enable: "Enable",
        disable: "Disable",
        comapletedDate: "Completed Date",
        taskId: "Task Id",
        noproject: "No Project",
        nodepartment: "No Department",
        noactivity: "No Activity",
        splaignrule: "Special Assignment Rule",
        myprofile: "My Profile",
        barChart: "Bar Chart",
        Piechart: "Pie chart",
        Radarchart: "Radar chart",
        Linechart: "Line chart",
        Areachart: "Area chart",
        OrganizationLogo: "Organization Logo",
        OrganizationName: "Organization Name",

        Organizations: "Organizations",
        ReportType: "Report Type",
        ForInstallmentPlan: "For Installment Plan",
        WorkflowNames: "Workflow Names",
        ReportLink: "Report Link",
        RequestedAt: "Requested At",
        Noguidelines: "No guidelines available",
        Deleteworkflowmsg:
            "Do you really want to leave? This action will delete your created workflow structure",
        MandatoryFields: "Mandatory Field",
        NonMandatoryFields: "Non-Mandatory Fields",
        BulkUpload: "Bulk Upload",
        CreateandAssigne: "Create and Assigne",
        AssetName: "Asset Name",
        UserId: "User Id",
        FieldStaffList: "Field Staff List",
        SUBMISSION: "SUBMISSION",
        NOT_COMPLETED: "NOT_COMPLETED",
        HideCriteria: "Hide Criteria",
        NewCriteria: "Add New Criteria",
        ActivityQuestions: "Select Activity Questions",
        FieldQuestion: "Select Field Question",
        Select: "Select",
        AddChart: "Add Chart",
        DeleteDash: "Are you sure you want to delete this dashboard?",
        DeleteGraph: "Are you sure you want to delete this graph metric?",
        CreateDash: "Create Activity Dashboard",
        Role: "Role",
        Activity: "Activity",
        selectWorkflow: "Select Workflow",
        ActivityName: "Activity Name",
        SelectChart: "Select Chart",
        ViewChart: "View Chart",
        RangeFilter: "Date Range Filter",
        selecrOrg: "Please select an organization",
        Page: "Page",
        FieldId: "Field Agent ID",
        FieldAgentName: "Field Agent Name",
        Action: "Action",
        RemarkReq: "Remarks are required.",
        adCustSupport: "Add customer Support",
        Clone: "Clone",
        SpecialRc: "Special RC",
        InteractiveRc: "Interactive RC",
        Viewinstallment: "View installment",
        createInstallment: "Create installment plan",
        CustomerId: "Customer Id",
        NoOfinstallment: "Number of installments ",
        advancepayamt: "Advance Payment Amount",
        advDate: "Advance Date",
        custDetail: "Customer Details",
        instalDetail: "Installment Details ",
        firstInstDate: "First Installment Date ",
        clrPreview: "Clear Preview",
        prevPlan: "Preview Plan ",
        submitRc: "Submit for RC",
        AfterAdv: "Outstanding After Advance",
        currentOut: "Current outstanding",

        Amount: "Amount ",
        Notes: "Notes ",
        Latitude: "Latitude ",
        Longitude: "Longitude ",
        selectFieldAget: "Select Field Agent ",
        planId: "Plan Id",
        planActive: "Plan Active ",
        planCreated: "Plan Created",
        outstaningAmt: "Outstanding Amount",
        Advamt: "Advance Amount",
        AdvDate: "Advance Payment Date",
        firstInsDate: "First Installment Date",
        noOfInst: "No of Installments",
        activeInst: "Active Installments",
        DetailId: "Detail Id ",
        PaymentId: "Payment Id,",
        PayAmt: "Payment Amount ",
        payDate: "Payment date ",
        Status: "Status ",
        PayPrev: "Payment Preview",
        OutAfteAdv: "Outstanding After Advance",
        CurrentOut: "Current outstanding ",
        NoinstAvlble: "No installment available ",
        title: "Blufield Utilities Tasks management solutions",
        userEmail: "Username/Email address ",
        remember: "Remember me",
        forgetpass: "Forget password",
        Login: "Login ",
        pressEnter: "Press Enter to add multiple account numbers",
        typeEnter: "Type a number and press Enter",

        payDetail: "Payment Details",
        cretDate: "Created Date",
        inactiveplane: "Inactive Installment Plans",
        instplanDetail: "Installment Plan Details",
        loogoutMsg: "Are you sure you want to logout?",
        Logout: "Logout",
        support: "Customer Support",
        supporttooltip: "RC Support System",
        powerbidashboard: "PowerBi Dashboard",
        installment: "Installment Plan",
        password: "Password",
        noDatavb: "No Data available",
        viewValidation: "view Validation",
        completedTaskCount: "Completed Task Count",
        taskpriority: " Task Priority",
        taskstatus: "Task Status",
        previous: "Prev",
        next: "Next",
        datefilterforchart: " Date for Completed Task",
        date: "Date",
        from: "From",
        to: "To",
        apply: "Apply",
        unassignn: "Unassign",
        dashboard: "Dashboard",
        dashboardtolltip: "Dashboard,View and manage your dashboard overview",
        usertooltip: "Users, Manage user accounts and roles",
        setting: "Settings",
        asset: "Asset Management",
        assettooltip: "Asset, View and manage your assets",
        config: "Configuration",
        configtooltip:
            "Configuration, Manage Assignment rules, custom rules and completion rules",
        task: "Task Manage",
        tasktooltip: "Task Manage, Manage your tasks and assignments, deletion",
        acchistory: "Account History",
        accReportsCenter: "ACCOUNT & REPORTS CENTER",
        historytooltip: "Account History, View the history of completed tasks",
        workflowe: "Workflow",
        workflowtooltip: "Workflow, Manage your workflows, Guidelines",
        worklog: "Worklog",
        worklogtooltip:
            "Worklog, View and manage your work logs, Export Excel Report, Export PDF",
        security: "Security",
        securitytooltip: "Security, Manage security settings",
        report: "Reports",
        reportooltip: "Reports, Request for report, Check status of the Reports",
        roleManagement: "Role Based Management",
        roleManagementtooltip: "Manage roles and permissions",
        createRole: "Create Role",
        updateRole: "Update Role",
        deleteRole: "Delete Role",
        roleName: "Role Name",
        confirmDeleteRole: "Are you sure you want to delete this role?",
        noRolesFound: "No roles found",
        org: "Organization",
        orgtooltip: "Organization, Manage Organization",
        stock: "Stock Management",
        stocktoooltip:
            "Stock Management, Update inventory Details, Download Report",
        //USER
        addUser: "Add User",
        searchusername: "Search by username...",
        searchareacode: "Search by areacode...",
        userType: "User Type",
        user: "User",
        edit: "Edit",
        userlist: "User Management",
        userdetail: "User Details",
        previllage: "Previleges",
        cancle: "Cancel",
        updateuser: "Update User",
        add: "Add User",
        username: "User Name",

        selectOrg: "Select Organization",
        areCode: "Area Code",
        addeditActivity: "Add/edit Activity",
        addnewlabel: "Add/Edit Configuration",
        addEdituser: "Add/edit User",
        canasset: "Can access asset Management",
        uservisibility: " User Visibility",
        modifyguidline: "Modifying Guidelines",
        createDashboar: "Create Dashboard",
        addeditleader: "Add/edit Leader-board",
        canTaskManage: "Can access Task Manage",
        canAddEditProtectedAccount: "Can Add /Edit Protected account",
        canAddEditInventory: "Can add/Edit Inventory Management",
        //SETTINGS
        general: "General",
        save: "Save Changes",
        langSetting: "Language Settings",
        colormode: "Color Mode",
        light: "Light",
        dark: "Dark",
        highcontrast: "High Contrast",
        lang: "Language",
        toursetting: "Tour Setting",
        stoptour: "Stop Tour",
        starttour: "Start Tour",
        custommarker: "Custom Marker",
        all: "All",
        assigned: "Assigned",
        active: "Active",
        progress: "In Progress",
        completed: "Completed",
        onhold: "On Hold",
        //ASSET
        vehical: "Vehical",
        Inventory: "Inventory",
        exportreport: "Export Report",
        addVehical: "Add New Vehical",
        addAsset: " Add New Asset",
        search: "Search",
        vehicalType: "Vehicle type",
        vehicalAssign: "Vehicle Assignee",
        searchbyId: "Search By Id...",
        assetType: "Asset type",
        assetAssign: "Asset Assignee",
        addnewasset: "Add New Asset",
        assetId: "Asset ID",
        agentAssigned: "Agent Assigned",
        assetStatus: "Asset Status",
        updateAsset: "Update Asset",
        Update: "Update",
        updateVehical: "Update Vehical",
        //CONFIGURATION
        complitionrule: "Completion Rules",
        assignment: "Assignment Rules",
        customerule: "Custom Variables",
        rulename: "Rule Name",
        assignTo: "Assign To",
        assingTask: "Assign Tasks",
        activedeactive: "Active / Deactive",
        criteria: "Criteria",
        submit: "Submit",
        update: "Update",
        norule: "No more rules to load",
        icon: "Icon",
        createrule: "Create new rule",
        addNewRule: "Add New Rule",
        multiSelect: "Multi Select",
        smartAssign: "Smart Assign",
        FieldStaff: "Field Staff",
        Location: "Location",
        MapStatus: "Map Status",
        fieldAgent: "Field Agent",
        allFieldAgents: "All Field Agents",
        createNewTask: " Create new task",
        importCSV: "Upload Task",
        mapview: "Mapview",
        createTask: "Create new task",
        listvbiew: "Task List View",
        download: "Download",
        downloadPdf: "Download PDF",
        refresh: "Refresh Table",
        deleteAllRecord: " Delete All Record",
        assign: "Assign",
        reassign: "Reassign",
        usercount: "User Counts",
        alert: "Sent Alert",
        delete: "Delete",
        priority: "Priority",
        status: "Status",
        searchbycode: "Search by Area Code..",
        selectAssign: "Select Assignee",
        downloadtask: " Download Task Report",
        seectallactivty: " Select All Activity",
        selectpartcular: " Selected Particular Activity",
        selectMsg: "Please select an activity to proceed.",
        createnewtask: "Create new task",
        cancel: "Cancel",
        create: "Create",
        DragDetail: "Drag and drop CSV containing all the task details",
        sizeMsg: "Max file size: 15MB",
        import: " Import CSV ",
        uploadfile: "Upload Task Sheet",
        uploadby: "Uploaded By",
        uploaddate: "Upload Date",
        uploadtime: "Upload Time (24hrs)",
        taskdetail: "Task Detail",
        taskhistory: " Task History",
        nohistory: "No task history available.",
        more: "Loading more task history...",
        enteraccno: " Enter Account Number",
        reset: " Reset",
        submitting: "Submitting..",
        accDetail: " Account Details",
        accnumber: "Account Number",
        area: "Area",
        areacode: "Area Code",
        latitude: "Latitude",
        longitude: "Longitude",
        importdb: "Import Master DB",
        exportData: " Export Report",
        downloading: "Downloading...",
        viewGuideline: "View Guideline",
        createWorkflow: "Create new Workflow",
        guidline: "Guidlines",
        noworkflow: "No workflows available",

        Scheduleemail: "  Schedule email report",
        export: "Export Report",
        pdf: "Export PDF",
        todo: "To do",
        loading: "Loading more worklog...",
        nomore: "No more worklog to load",
        name: "Protected Account",
        createacc: "Create new account",

        editacc: "Edit Protected Account",
        createproacc: "Create Protected Account",
        permanent: "Permanent Protection",
        protectionValid: "Protection Valid to",
        createdBy: "createdBy",
        accProtection: "Account Protection for All Activity",
        accno: "Account No",
        remark: "Remarks",
        enterremark: "Enter your remarks here",
        updatemeterDEtail: "Update Meter Details",
        downloadsheet: "Download Sheet",
        uploadinventory: "Upload Inventory Sheet",
        reportType: "Report Type",

        form: "Request Report",
        uploadSheet: "Upload Sheet",
        startDate: "Start Date",
        endDate: " End Date",
        request: "Request",

        orglist: " Orgnizations List",
        createOrg: " Create Orgnization",
        noOrg: " No organization data available.",
        rows: "Rows per page",
        orgname: "Organization Name",
        img: "  Upload Logo",

        creating: "Creating...",
        updateOrg: "Update Organization",

        Updating: "Updating...",
        nolog: "No Logo",
        number: "No.",
        geoCodes: "Selected Geo Codes",
        typeCodes: "Selected Type Codes",
        amountRange: "Selected Amount Range",
        assignAll: "Assign All",
        default: "Default",
        //dashbord
        userdashboard: "User Dashboard",
        activitydashboard: "Activity Dashboard",
        admin: "Admin",
        office_user: "Office Users",
        field_agent: "Field Agents",
        dashboardName: "Dashboard Name",
        addnewDashboard: "Add New Dashboard",
        chartMessage: " Select the Dashboard to view charts",
        deletDashbord: "Delete Dashboard",
        //notifucation
        notification: "Notification",
        allnotification: "All Notification",
        profile: "Profile",
        select: " Select Activity",
        selecteOrgName: "Select Organization",
        selectsubactivty: "Select Subactivity",

        emailreport: "Schedule Email Report",
        selectactivity: "Select the activity:",
        recipients: "Recipients",
        bcc: "Bcc",
        cc: "Cc",
        sendreport: "Send scheduled report",
        senddashboard: "Send Dashboard:",
        shedulesend: "Schedule send:",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",

        send: "Send",
        reportbtn: "Request Report",


        stockmanag: "Stock Management",
        fromdate: "From Date",
        todate: "To Date",
        metercode: "Meter Bar Code",
        location: "To Location",
        filter: "Apply Filters",
        addbtn: "Add",
        updatetaskdetail: "Update Task Details",
        discard: "Discard",
        Confirm: "Confirm",
        visitTime: "Visit Time",
        visitDate: "Visit Date",
        nopdfavb: "PDF is not available.",

        // login
        Utilities: "Utilities &",
        TasksManagementSolutions: "Tasks Management Solutions",
        UsernameEmailAddress: "Username / Email Address",
        RememberMe: "Remember Me",
        ForgotPassword: "Forgot Password?",
        assetBarCode: "Asset Barcode",
        dragAndDropDocuments: "Drag and drop Documents",
        viewDocuments: "View Documents",
        uploadedDocument: "Uploaded Document",
        maxFileSize5MB: "Max file size: 5MB",
        browse: "Browse",
        description: "Description",
        kilometer: "Kilometer",
        noAccountDetialsAvailable: "No account details available",
        enterAccSubmitViewDetails:
            "Enter an account number and submit to view details",
        uploading: "Uploading",
        upload: "Upload",
        addOrganization: "Add Organization",
        addDepartment: "Add Department",
        uploadOrganizationLogo: "Upload Organization Logo",
        successMessage:
            "Please wait! The file is being uploaded. It may take some time, and once successfully uploaded, you will receive a success message.",
        fullName: "Full Name",
        department: "Department",
        project: "Project",
        profileImage: "Profile Image",
        vehicleId: "Vehicle ID",
        vehicleKM: "Vehicle (KM)",
        vehicleAssinged: "Vehicle Assigned",
        editPrivileges: "Edit Privileges",
        source: "Source",
        thecustomcodewarningmessage:
            "The custom marker color not added, select from below !!",
        selectWorkflowFirst: "Select workflow first",
        makerColor: "Marker colors saved successfully!",
        failedtoSaveMakerColor: "Failed to save marker color!",
        permanentProtection: "Permanent protection will not have an end date",
        noRecordAvailable: "No record Available",
        reportGenerating: "Report is Generating...",
        mediumPriority: "Medium Priority",
        highPriority: "High Priority",
        lowPriority: "Low Priority",

        accountProtection: "Account Protection",
        clockIn: "clock in",
        clockOut: "clock out",
        showAsFilter: "Show as filter",
        English: "English",
        Urdu: "Urdu",
        Arabic: "Arabic",
        History: "History",
        Heading: "Heading",
        Name: "Name",
        Email: "Email",
        Phone: "Phone",
        Address: "Address",
        DatePicker: "Date Picker",
        TakePhoto: "Take Photo",
        MultipleImages: "Multiple Images",
        Signature: "Signature",
        RadioButton: "Radio Button",
        Checkbox: "Checkbox",
        Dropdown: "Dropdown",
        Number: "Number",
        Time: "Time",
        LongText: "Long Text",
        Barcode: "Barcode",
        wfElTooltipHeading: "Use this to add a heading.",
        wfElTooltipName: "Enter the name for the field.",
        wfElTooltipEmail: "Enter a valid email address.",
        wfElTooltipPhone: "Enter a phone number.",
        wfElTooltipAddress: "Enter the address.",
        wfElTooltipDate: "Select a date from the calendar.",
        wfElTooltipPhoto: "Upload a photo.",
        wfElTooltipMultiImage: "Upload multiple images.",
        wfElTooltipSignature: "Add a signature.",
        wfElTooltipRadio: "Choose one option from multiple choices.",
        wfElTooltipCheckbox: "Select multiple options if applicable.",
        wfElTooltipDropdown: "Select an option from the dropdown list.",
        wfElTooltipNumber: "Enter a numerical value.",
        wfElTooltipTime: "Pick a specific time.",
        wfElTooltipLongText: "Enter detailed text or descriptions.",
        wfElTooltipBarcode: "Scan a barcode for input.",
        wfElTooltipOcr: "Optical Character Recognition.",
        wfElTooltipGps: "Global Positioning System.",
        workflowModalPreviewOptionsEmpty:
            "Add choices in the form builder to see them here.",
        NotificationSound: "Notification Sound",
        TestSound: "Test Sound",
        Configurations: "Configurations",
        TermsAndConditions: "Terms and Conditions",
        DragDropTermsConditionFile: "Drag and drop Terms and Condition file",
        PrivacyAcceptance: "Privacy Acceptance",
        DragDropPrivacyAcceptanceFile: "Drag and drop Privacy Acceptance file",
        TermsandConditionPdf: "TermsandCondition.pdf",
        view: "view",
        NoReportDataavailble: "No Report Data availble",
        UnexpectedResponseFormat: "Unexpected response format. Please try again.",
        chooseFile: "Choose File",
        noFile: "No file chosen",
        PasswordRequired: "Password is required",
        PasswordMustBeAtLeast8Characters: "Password must be at least 8 characters",
        IncludeDeletedRecords: "Include Deleted Records",

        pleaseFillAllFieldsBeforeSaving: "Please fill all fields before saving",
        ruleCreatedSuccessfully: "Rule Created Successfully",
        pleaseSelectFromDateToDate: "Please select both From Date and To Date.",
        exportBtn: "Export",
        importBtn: "Import",
        addTaskBtn: "Add Task",
        attachProof: "Attach Proof (PDF/Image)",
        activityAnalytics: "Activity Analytics",
        analyticsStatusLabel: "Status",
        chartSelectFiltersHint:
            "Select activity, status and dates to view chart",
        chartLoading: "Loading...",
        taskActions: "Task Actions",
        selectedLocation: "Selected Location",
        drawnArea: "Drawn Area",
        clearSelection: "Clear",
        clickMarkerForLocationDetails:
            "Click a marker on the map to see location details",
        taskDetailsSection: "Task Details",
        loadingTaskDetails: "Loading task details...",
        clickMarkerLoadTaskDetails: "Click a marker to load task details.",
        taskStatusSection: "Task Status",
        availableAgents: "Available Agents",
        searchFieldAgentsPlaceholder: "Search field agents...",
        noAgentsMatchSearch: "No agents match your search",
        noAgentsAvailable: "No agents available",
        loadingAgentsLabel: "Loading agents...",
        statusActiveLabel: "Active",
        statusInProgressLabel: "In Progress",
        statusCompletedLabel: "Completed",
        statusAssignedLabel: "Assigned",
        statusOnHoldLabel: "On Hold",
        unassignedLabel: "Unassigned",
        taskIdLabel: "Task ID",
        assigneeLabel: "Assignee",
        completedCountSuffix: "Completed",
        tasksInDrawnAreaTitle: "Tasks in drawn area",
        tasksListTitle: "Tasks",
        centerApproxLabel: "CENTER (APPROX.)",
        latLongUpperLabel: "LAT/LONG",
        agentUpperLabel: "AGENT",
        activeTasksUpperLabel: "ACTIVE TASKS",
        taskWord: "Task",
        tasksWord: "Tasks",
        assignTaskCountVerb: "Assign",
        taskSingular: "task",
        tasksPlural: "tasks",
        onlineLabel: "Online",
        offlineLabel: "Offline",
        showOnlineAgentsTitle: "Show online agents",
        showOfflineAgentsTitle: "Show offline agents",
        onlyActiveTasksAssignableTitle: "Only Active tasks can be assigned",
        consNameEnglish: "Consumer name (English)",
        consNameArabic: "Consumer name (Arabic)",
        meterNoLabel: "Meter No.",
        consumerTypeLabel: "Consumer Type",
        phoneLabel: "Phone",
        lastReadTypeLabel: "Last reading type",
        lastReadingLabel: "Last reading",
        lastReadingDateLabel: "Last reading date",
        averageLabel: "Average",
        instalmentPlanNotExisting:
            "Instalment plan not existing for the given account number",
        remarksError: "Remarks field is required",
        previewPlanError: "We encountered an unexpected error.",

        meterBarCode: "Meter Bar Code",
        components: "components",
        meterType: "meter Type",
        manufacturingYear: "manufacturing Year",
        meterMake: "Meter Make",
        activationDate: "activation Date",
        batchNo: "batch No",
        installationStatus: "installation Status",
        createBy: "Created By",
        createdAt: "Created At",
        simNo: "sim No",
        ipAddress: "ip Address",
        iccid: "iccid",
        apn: "apn",
        op: "op",
        balance: "balance",
        simDetailUpdatedAt: "sim Detail Updated At",
        transferredFrom: "transferred From",
        transferredTo: "transferred To",
        DragYourElementsToSecondPageFromLeftPanel: "Drag your elements to second page from left panel",
        Deactive: "Deactive",
        Yes: "Yes",

        WhatDoYouWantExistingAccounts: "What do you want to do with Existing Accounts?",
        updateAlreadyExistingAccountEntries: "Update already Existing Account Entries ?",
        createNewAccountEntries: "Create new Account Entries ?",
        customerDetails: "Installment Creation Detail",
        created_By: "Created By",
        accountNo: "Account No.",
        civilId: "Customer Id",
        phoneNo: "Phone No.",
        comment: "comment",
        employee: 'Employee', // employed id added by harshit vachhani
        subContract: 'SubContract', // subContract added by harshit vachhani
    },
    ar: {
        accountreportcenter: 'مركز الحسابات والتقارير',
        PDF: "PDF",
        viewdetails: ' عرض التفاصيل',
        addnewvehicale: 'أضف مركبة جديدة إلى قائمة الأصول الخاصة بك.',
        cancelandstay: 'إلغاء والبقاء على الصفحة',
        confirmandlogout: 'تأكيد وتسجيل الخروج',
        welcome: 'مرحباً',
        welcomeback: 'مرحبًا بعودتك',
        editandudateasset: 'تحرير وتحديث تفاصيل الأصل',
        assigntheselected: 'تعيين المركبة المحددة إلى موظف ميداني',
        updatetherule: ' تحديث القاعدة',
        submitherule: ' إرسال القاعدة',
        addassignmentrule: ' إضافة قاعدة تعيين',
        savetherule: 'حفظ القاعدة',
        addcompletionrule: '  إضافة قاعدة إتمام',
        addcustomrule: ' إضافة قاعدة مخصصة',
        assignallactiverules: ' تعيين جميع القواعد النشطة',
        addnewspecialassingmentrule: '  إضافة قاعدة تعيين خاصة جديدة',
        updatetherulewitjselectedpara: ' تحديث القاعدة بالمعايير المحددة',
        createneweulwwithselected: '  إنشاء قاعدة جديدة بالمعايير المحددة',
        cancelandclose: ' إلغاء وإغلاق النافذة',
        addnewdashboardtooltip: 'إضافة لوحة معلومات جديدة (يمكنك إنشاء لوحة المعلومات بناءً على سير العمل)',
        processthenextstep: ' متابعة إلى الخطوة التالية',
        deletethedashboard: ' حذف لوحة المعلومات',
        createdashboardtooltip: ' إنشاء لوحة المعلومات ',
        canceltheselectedchart: 'إنشاء المخطط المحدد',
        applytheselecteddaterange: ' تطبيق نطاق التاريخ المحدد',
        downloadfilterdate: '  تنزيل البيانات بعد تطبيق الفلتر',
        proceedwiththeaction: '  المتابعة في تنفيذ الإجراء',
        addnewproject: ' إضافة مشروع جديد',
        addnewdepartment: ' إضافة قسم جديد',
        addneworgnization: '  إضافة مؤسسة جديدة',
        updateorgnizations: ' تحديث بيانات المؤسسة',
        savethechangesmadetomarkers: ' حفظ التغييرات التي تمت على ألوان العلامات',
        updatethechangesmade: ' تحديث التغييرات التي تمت على ألوان العلامات',
        cancelanddiscardchanges: ' إلغاء وتجاهل التغييرات',
        requestthereport: ' طلب التقرير',
        savetheprotectedaccount: ' حفظ الحساب المحمي',
        submitthereportrequest: ' إرسال طلب التقرير',
        cancelandgoback: ' إلغاء والعودة للخلف',
        exportthexcelfilebasedon: ' تصدير ملف ‎Excel‎ بناءً على عوامل التصفية',
        createaprotectedaccountwithpermanent: '  إنشاء حساب محمي بحماية دائمة أو لمدة محددة',
        downloadthereportfortheselecte: ' تنزيل التقرير للفترة الزمنية المحددة',
        uploadtheinventorysheet: ' رفع ملف ‎Excel‎ للمخزون',
        downloadincentoryreport: 'تنزيل تقرير المخزون',
        applythesleectedfilters: 'تطبيق عوامل التصفية المحددة ',
        uploadtheselectedexcelfile: ' رفع ملف ‎Excel‎ المحدد',
        createinstallmentplan: 'إنشاء خطة أقساط',
        generatepreviewfiter: '(إنشاء المعاينة أولًا)',
        emiamount: '(مبالغ الأقساط ‎EMI‎ لا تطابق المبلغ المستحق)',
        finisheditinisntall: '  (إنهاء تعديل الأقساط) ',
        savechangesbeforesubmiting: ' (احفظ التغييرات قبل الإرسال)',
        totalemaiamount: ' (إجمالي مبلغ الأقساط ‎EMI‎ لا يمكن أن يكون سالبًا)',
        userscancreateup: ' (يمكن للمستخدم إنشاء ما يصل إلى 6 أقساط فقط)',
        printpreviewtable: 'طباعة جدول المعاينة',
        generatepreview: ' إنشاء المعاينة',
        clearpreviewdata: ' مسح بيانات المعاينة',
        submitforRccreation: ' إرسال لإنشاء ‎RC‎',
        savethechagesmadeto: ' حفظ التغييرات على مبالغ الدفعات',
        editthepaymentamount: ' تعديل مبالغ الدفعات',
        submitspecialRc: '  إرسال ‎RC‎ خاص',
        printinstallmentdetails: ' طباعة تفاصيل الأقساط',
        proceedwithdeleaction: ' المتابعة في إجراء الحذف',
        deletetheselectedtask: ' حذف المهمة المحددة',
        unassignntheseledtask: ' إلغاء تعيين المهمة المحددة',
        reassigntheselectedtask: ' إعادة تعيين المهمة المحددة',
        assigntheselectedtask: 'تعيين المهمة المحددة',
        multiselecte: ' تحديد متعدد',
        addemailenablrnotifi: ' إضافة عناوين البريد الإلكتروني، وتفعيل الإشعارات، وضبط الإعدادات الأخرى',
        donwloadthetaskrecordin: ' تنزيل سجل المهام بصيغة ‎Excel‎ بناءً على النشاط المحدد أو لجميع الأنشطة',
        createtaskbulk: ' إنشاء مهمة جديدة، أو إنشاؤها وتعيينها، أو رفع المهام دفعة واحدة',
        uploadthetasksheet: 'رفع ملف المهام',
        assingtaskbasedonselectedrules: 'تعيين المهام بناءً على القواعد المحددة',
        reassigningprocess: 'إعادة التعيين قيد التنفيذ',
        reassingselectedtasktochosen: ' إعادة تعيين المهام المحددة إلى الموظفين الميدانيين المختارين',
        assingtaskbasedonselectedrule: '— تعيين المهام بناءً على القواعد المحددة',
        reassinginginprocess: 'إعادة التعيين قيد التنفيذ',
        reassignselectedtasktochosenfield: 'إعادة تعيين المهام المحددة إلى الموظفين الميدانيين المختارين',
        unassignselectedassingeesfromtask: 'إلغاء تعيين المكلّفين المحددين من المهام',
        savetheupdateddatacompleted: 'حفظ البيانات المحدّثة للمهام المكتملة',
        gobacktheprivious: ' العودة إلى الشاشة السابقة دون حفظ',
        resetthecompletiondata: ' إعادة تعيين بيانات إتمام المهمة',
        closewithoutsavingchnages: ' إغلاق دون حفظ التغييرات',
        savechangesmadetothefield: ' حفظ التغييرات التي تمت على الحقل',
        viewworkflowguidlines: 'عرض إرشادات سير العمل',
        createnewworkflows: 'إنشاء سير عمل جديد',
        selectorgtocreateaworkflow: 'اختيار مؤسسة لإنشاء سير العمل',
        scheduleemail: ' جدولة بريد إلكتروني',
        exporttheexcelfilebasedonfilters: ' تصدير ملف ‎Excel‎ بناءً على عوامل التصفية',
        exportpdfbasedonfilters: ' تصدير ملف ‎PDF‎ بناءً على عوامل التصفية',
        downloadpdfbasedonfilters: ' تنزيل ملف ‎PDF‎ بناءً على عوامل التصفية',
        savechangesforprofile: ' حفظ التغييرات في الملف الشخصي',
        requestonewreport: 'طلب تقرير جديد',
        createamanualtask: ' إنشاء مهمة يدوية',
        createandassingtasktofield: ' إنشاء وتعيين مهمة لموظف ميداني',
        closethedialogbox: 'إغلاق نافذة الحوار',
        gobacktomapmandotoryfield: ' العودة لتعيين الحقول الإلزامية',
        submitmappeddataandstartupload: ' إرسال البيانات المعيَّنة وبدء عملية الرفع',
        procestomapnonmdaotry: ' المتابعة لتعيين الحقول غير الإلزامية',
        gobacktotaskpriority: ' العودة إلى اختيار أولوية المهام',
        proceestomapmadatory: ' المتابعة لتعيين الحقول الإلزامية',
        gobackprivousscren: ' العودة إلى الشاشة السابقة دون حفظ',
        addmultipleaccount: ' إضافة أرقام حسابات متعددة وتعيين المهام للموظفين الميدانيين',
        selectatleast: 'يرجى اختيار موظف ميداني واحد على الأقل للتعيين',
        assingmentinprocess: ' التعيين قيد التنفيذ',
        assingselectedtasktochosen: 'تعيين المهام المحددة إلى الموظفين الميدانيين المختارين',
        recallassingedtask: ' استرجاع المهام المعيّنة من المستخدمين',
        deleterecordfrom: ' حذف السجلات من الملف المرفوع',
        donwloastheuplodedexcel: 'تنزيل ملف ‎Excel‎ الذي تم رفعه',
        uploasthexcelfile: ' رفع ملف ‎Excel‎ للنشاط المحدد',
        savethechanges: ' حفظ التغييرات',
        diacardchanges: ' تجاهل التغييرات',
        proceedtomapnonmdfield: ' المتابعة لتعيين الحقول غير الإلزامية',
        submitthemapedcol: ' إرسال الأعمدة المعيّنة ورفع البيانات',
        uploadtheslectedfile: ' رفع الملف المحدد',
        uploadtheaccountexcel: ' رفع ملف حسابات ‎Excel‎ إلى قاعدة البيانات الرئيسية',
        clearalldata: 'مسح جميع البيانات',
        fetchtheaccounthistory: ' جلب سجل الحساب للرقم المُدخل',
        donwlaodthetaskreportinpdfformat: 'تنزيل تقرير المهام بصيغة ‎PDF‎',
        editandupdateuserdetail: 'تحرير وتحديث تفاصيل المستخدم',
        saveandcreateuser: ' حفظ وإنشاء مستخدم',
        donotsavechangesgoback: 'عدم حفظ التغييرات والعودة',
        addauserassingroles: ' إضافة مستخدم وتعيين الأدوار أو الصلاحيات',
        previewcurrentworkflowlayout: ' معاينة تخطيط سير العمل الحالي والحقول',
        submitworkflow: ' إرسال سير العمل',
        pleaseselectatleastonefild: 'يرجى اختيار حقل واحد على الأقل للتقرير',
        plzmakesuretosetauique: ' يرجى التأكد من تعيين اسم فريد لسير العمل قبل الاستنساخ',
        updatetheworkflowiwth: ' تحديث سير العمل بأحدث التغييرات',
        addnewvalidation: 'إضافة تحقق جديد',
        closewithoutsavingchanges: ' إغلاق دون حفظ التغييرات',
        viewwxistinfcalidation: 'عرض عمليات التحقق الحالية',
        savechangesmadetovalidation: ' حفظ التغييرات التي تمت على عمليات التحقق',
        discarchangesandexit: ' تجاهل التغييرات والخروج',
        savetheupdateddata: 'حفظ البيانات المحدّثة للمهام المكتملة',
        addselectefield: ' إضافة الحقول المحددة إلى التقرير',
        gotonextpage: ' الانتقال إلى الصفحة التالية',
        gotopreviouspage: ' الانتقال إلى الصفحة السابقة',
        refeshreportlist: ' تحديث قائمة التقارير',
        gobackpreviouspage: ' العودة إلى الصفحة السابقة',
        requestreporbasedonfilter: 'طلب تقرير بناءً على عوامل التصفية',
        filteredReports: 'التقارير المفلترة',
        pleaseSelectLeastAssetBeforeAssigning:
            "يرجى اختيار أصل واحد على الأقل قبل الإسناد.",
        plzselectfieldagent: 'يرجى اختيار فني ميداني.',
        assetsucassigned: 'تم إسناد الأصول بنجاح.',
        assetsfailedassigned: 'تعذّر إسناد الأصول',
        logout: 'تم تسجيل الخروج بنجاح.',
        rulecreated: 'تم إنشاء القاعدة بنجاح.',
        unexpectederroroccured: ' حدث خطأ أثناء إرسال النموذج. يرجى التواصل مع دعم Blufield على help@blufield.net. ',
        plzselworkflow: 'يرجى اختيار سير العمل قبل إضافة المعايير.',
        ruledeleted: 'تم حذف القاعدة بنجاح.',
        failedelrule: 'تعذّر حذف القاعدة.',
        PleaseSelectWorkflowBeforeAddingRule:
            " يرجى اختيار سير العمل قبل إضافة قاعدة",
        failtoloadasign: 'تعذّر تحميل قواعد الإسناد. يرجى التواصل على help@blufield.net.',
        plzfillallfield: 'يرجى تعبئة جميع الحقول الإلزامية للإرسال.',
        failedtoassign: 'تعذّر إسناد جميع القواعد. يرجى التواصل على help@blufield.net.',
        OnClickTheOldAssignmentRuleDisabled:
            " عند النقر، سيتم تعطيل قاعدة الإسناد السابقة.",
        invalideruleid: 'معرّف القاعدة غير صالح.',
        plzselfield: "يرجى اختيار فني ميداني.",
        failedtoloadruledata: 'تعذّر تحميل بيانات القاعدة. يرجى التواصل على help@blufield.net.',
        nopermission: 'لا تملك الأذونات اللازمة لعرض هذه الصفحة. يرجى التواصل على help@blufield.net. ',
        plzselectorg: 'يرجى اختيار منظمة.',
        somthingwentwrong: ' حدث خطأ ما! يرجى التواصل على help@blufield.net.',
        excelisdownloading: 'يتم تنزيل ملف Excel…',
        norecordfound: 'لا توجد سجلات.',
        anerroroccurred: 'حدث خطأ أثناء تنزيل التقرير. يرجى التواصل على help@blufield.net.',
        orgaddedsuc: 'تمت إضافة المنظمة بنجاح.',
        errorcreatingorg: 'حدث خطأ أثناء إنشاء المنظمة. يرجى التواصل على help@blufield.net.',
        failstofetchorg: 'تعذّر جلب بيانات المنظمة.',
        orgupdated: 'تم تحديث المنظمة بنجاح.',
        allfieldarerequired: 'كل الحقول مطلوبة.',
        reportreqsuc: 'تم إرسال طلب التقرير بنجاح.',
        errorequestreport: 'حدث خطأ أثناء طلب التقرير.',
        addremark: 'أضف ملاحظة!',
        protectedAcccreated: ' تم إنشاء حساب محمي.',
        protectedAccUpdated: 'تم تحديث الحساب المحمي.',
        errorcreatingprotacc: 'حدث خطأ أثناء إنشاء الحساب المحمي.',
        pleaseSelectOrganizationCreatingAccount:
            "يرجى اختيار منظمة قبل إنشاء حساب.",
        pleaseSelectProjectIdFirst: "يرجى اختيار مشروع أولًا.",
        norecordareavailbles: 'لا توجد سجلات متاحة.',
        downloadlinkmissing: 'رابط التنزيل غير موجود.',
        invalidresponse: 'تنسيق الاستجابة غير صالح.',
        failedFetchReports: "تعذّر جلب التقرير.",
        reportgeneratedsuccc: 'تم إنشاء التقرير بنجاح!',
        pleaseSelectRecordProceed: "يرجى اختيار سجل للمتابعة!",
        errorOccurredWhileDeletingRecord:
            "حدث خطأ أثناء حذف السجل.",
        failedtofetchmeter: 'تعذّر جلب تفاصيل مخزون العدادات.',
        userStatusupdatesuc: 'تم تحديث حالة المستخدم بنجاح.',
        failedtoupdateuserstatus: 'تعذّر تحديث حالة المستخدم.',
        fileuploadedsucc: 'تم رفع الملف بنجاح.',
        failedtouploadfiles: 'تعذّر رفع الملف. يرجى التواصل على help@blufield.net.',
        pleasegeneratepreview: 'يرجى إنشاء المعاينة قبل إنشاء القسط.',
        failedtogeneratepdf: ' تعذّر إنشاء ملف PDF. يرجى المحاولة مرة أخرى أو التواصل معنا على help@blufield.net.',
        installmentupdated: 'تم تحديث خطة الأقساط بنجاح!',
        installmentplancretsuc: 'تم إنشاء خطة الأقساط بنجاح!',
        errorgeneratingpdf: ' حدث خطأ أثناء إنشاء ملف PDF أو إرسال خطة الأقساط!',
        failedtoconnectserver: 'تعذّر الاتصال بالخادم. يرجى المحاولة مرة أخرى.',
        youcannotpaythefullamount: 'لا يمكنك دفع المبلغ كاملًا في قسط واحد. يرجى توزيعه على جميع الأقساط.',
        eachinstallmentmusthave: ' يجب أن يحتوي كل قسط على الحد الأدنى على الأقل.',
        changesavedsuc: 'تم حفظ التغييرات بنجاح!',
        plzwentervalidacc: 'يرجى إدخال رقم حساب صالح.',
        fieldagentassinged: 'تم تعيين الفني الميداني.',
        NoasssingData: "لا تتوفر بيانات للمسنَد إليهم.",
        unAssignTaskSuccessMeg: "تم استلام طلبك ويجري معالجته في الخلفية. ستتلقى إشعارًا عند اكتماله.",
        pleaseselect: "اختر سير العمل أولًا.",
        plzenteracommentbeforedel: 'يرجى إدخال تعليق قبل حذف المهمة.',
        taskdelsuccessfully: 'تم حذف المهمة بنجاح.',
        erroccureduringtask: 'حدث خطأ أثناء إسناد المهام.',
        failedtoassignbyarea: 'تعذّر إسناد المهام حسب المنطقة.',
        plzselectactivity: 'يرجى اختيار نشاط.',
        noassigneselectedfor: 'لم يتم اختيار مسنَد إليهم لإلغاء الإسناد.',
        delteallrecord: 'تم حذف جميع السجلات.',
        taskprioriyupdated: 'تم تحديث أولوية المهمة.',
        pdfnotavailable: ' ملف PDF غير متاح.',
        datafetchedsuccessfully: 'تم جلب البيانات بنجاح.',
        anerroroccuredtaskhistory: 'حدث خطأ أثناء جلب سجل المهمة.',
        taskupdatedcussfully: 'تم تحديث المهمة بنجاح.',
        erroruploadingfileplztry: ' تعذّر رفع الملفات. يرجى التواصل على help@blufield.net.',
        orgismissingnotdrag: 'معرّف المنظمة مفقود؛ لا يمكن السحب!',
        nochangwsmadetothe: 'لم تُجرَ أي تغييرات على نوع الحقل.',
        selectOrgWarning: "اختر المنظمة أولًا.",
        pleaseselectdayreport: 'يرجى اختيار يوم التقرير.',
        reportprocesucc: 'تمت معالجة التقرير بنجاح!',
        nofileselc: 'لم يتم اختيار أي ملف.',
        filesizeexceeds: 'حجم الملف يتجاوز 5 MB.',
        invalidfiletypeplimg: 'وع الملف غير صالح. يرجى رفع صورة.',
        invalidfiletypedouc: 'نوع الملف غير صالح. يرجى رفع مستند.',
        unsupportedfile: 'نوع ملف غير مدعوم.',
        plzfillallfieldbeforeadd: 'يرجى تعبئة جميع الحقول قبل إضافة أصل.',
        assetaddedscucceffuly: 'تمت إضافة الأصل بنجاح.',
        fillFieldbeforeAddVehical:
            "يرجى تعبئة جميع الحقول قبل إضافة مركبة.",
        assetupdatedsuc: ' تم تحديث الأصل بنجاح.',
        vehicalupdatedsuc: 'تم تحديث المركبة بنجاح.',
        emailidorpass: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
        loginConnectionError:
            'تعذر الاتصال بالخادم. تحقق من اتصال الإنترنت وحاول مرة أخرى.',
        loginFailed: 'تعذر تسجيل الدخول. يرجى المحاولة مرة أخرى.',
        accessdenied: 'تم رفض الوصول!',
        otpverifiedsuc: 'تم التحقق من رمز التحقق (OTP) بنجاح.',
        failedtoverifyotp: 'تعذّر التحقق من رمز التحقق (OTP).',
        noworkflowinorg: 'لا تتوفر سير عمل لهذه المنظمة.',
        plzuploadpdffileonly: ' يرجى رفع ملفات PDF أو الفيديو فقط.',
        guidlineuplodsucc: 'تم رفع الدليل بنجاح.',
        invalidfiletype: ' نوع الملف غير صالح. يرجى رفع JPG أو PNG أو GIF.',
        emailnotavailble: 'البريد الإلكتروني غير متاح. يرجى التأكد من تحميل ملفك الشخصي.',
        youcanotmodify: 'لا يمكنك تعديل كلمة المرور الحالية ما لم يتم مسحها أولًا.',
        youcanowenter: 'يمكنك الآن إدخال كلمة مرور جديدة.',
        passowrdmust: 'يجب أن تتكون كلمات المرور من 8 أحرف على الأقل وأن تتضمن حرفًا كبيرًا وحرفًا صغيرًا ورقمًا ورمزًا خاصًا.',
        profileupdated: 'تم تحديث الملف الشخصي.',
        failedtofetchemails: 'تعذّر جلب الرسائل الإلكترونية.',
        enteremailfirst: 'أدخل بريدك الإلكتروني أولًا، ثم يمكنك تفعيل إشعارات البريد الإلكتروني.',
        statusupdatedsucc: 'تم تحديث الحالة بنجاح.',
        failedtoupdatednotifcation: 'تعذّر تحديث إعدادات الإشعارات.',
        errorfiledownloaded: 'خطأ: تم تنزيل الملف.',
        fileuploadedaborteddue: 'تم إلغاء رفع الملف بسبب خطأ.',
        plxselectanoption: 'يرجى اختيار خيار.',
        pleasefillallmandtoryfield: 'يرجى تعبئة جميع الحقول الإلزامية للمتابعة.',
        uploadcanceled: 'تم إلغاء الرفع.',
        nodatavailvle: 'لا توجد بيانات متاحة.',
        nofieldavailable: 'لا توجد حقول متاحة.',
        categoriyaddedsucc: 'تمت إضافة الفئة بنجاح.',
        plzselectdeltype: 'يرجى اختيار نوع الحذف.',
        failedtodelfile: 'تعذّر حذف الملف.',
        uploadedtasksheet: 'تم عرض قائمة ملفات المهام المرفوعة في الجدول!',
        nomoredatatoload: 'لا توجد بيانات إضافية للتحميل.',
        taskdetailupdatedsuc: 'تم تحديث تفاصيل المهمة بنجاح!',
        norecordavbforthisacc: 'لا يوجد سجل لرقم الحساب هذا. يرجى تجربة رقم حساب آخر.',
        userupdatedsuc: 'تم تحديث المستخدم بنجاح.',
        usercreatedSuc: 'تم إنشاء المستخدم بنجاح.',
        failedtofetchusers: 'تعذّر جلب المستخدمين.',
        nofieldabuplodtasksheet: 'لا توجد حقول متاحة. يرجى رفع ملف المهام أولًا للحصول على حقول إضافية.',
        nomoreuniqueversion: 'لا مزيد من الإصدارات الفريدة المتاحة.',
        nomoreversionavailble: 'لا مزيد من الإصدارات المتاحة.',
        createworkflowdiagram: 'إنشاء سير عمل.',
        updatepdfnamefirst: 'حدّث اسم ملف PDF أولًا.',
        pdfnameupdate: 'تم تحديث اسم ملف PDF بنجاح.',
        updatereportname: 'حدّث اسم التقرير أولًا.',
        excelnameupdate: 'تم تحديث اسم ملف Excel بنجاح. ',
        inputvlueadded: 'تمت إضافة قيمة الإدخال!',
        warningthis: 'تحذير: هذا الخيار مُدرج بالفعل في سير العمل. الإزالة مُقيّدة.',
        fieldremoved: 'تمت إزالة الحقل.',
        fieldcloned: 'تم استنساخ الحقل.',
        clonedsuc: 'تم الاستنساخ بنجاح.',
        pleaseentername: 'يرجى إدخال اسم لسير العمل المستنسخ.',
        inputfield: 'لا يمكن أن يكون حقل الإدخال فارغًا!',
        warningalready: 'تحذير: هذا الخيار مضاف بالفعل في تدفق العمل. الإزالة مقيدة. يمكنك فقط تعديل اسم هذا الخيار.',
        validationremoved: 'تمت إزالة التحقق، حدث تدفق العمل للحذف.',
        validationnotapplicable: 'لا ينطبق التحقق على هذا النوع من الحقول.',
        updatetheworkflow: 'حدّث سير العمل لحفظ هذه الحقول الإضافية.',
        failedtoupdatefield: 'تعذّر تحديث الحقول. يرجى المحاولة مرة أخرى.',
        pleaseSelectLeastActivity: "يرجى اختيار نشاط واحد على الأقل.",
        failedSubmitReportRequest: "تعذّر إرسال طلب التقرير.",
        urlnotprovided: 'لم يتم توفير عنوان URL في الاستجابة.',
        failedtoaddasset: ' تعذّر إضافة الأصل.',
        vehicleaddedsuc: 'تمت إضافة المركبة بنجاح.',
        failToAddVehical: "تعذّر إضافة المركبة.",
        ruleupdatedsuc: 'تم تحديث القاعدة بنجاح!',
        filesdeleted: ' تم حذف الملف.',
        plzselectatleatone: 'يرجى اختيار مهمة واحدة على الأقل للإسناد.',
        plzselectedforilfagrntoasing: 'يرجى اختيار فني ميداني لإسناد المهام.',
        invalidworkflow: 'سير العمل غير صالح. يرجى المحاولة مرة أخرى.',
        softdeletedsucc: 'تم الحذف المنطقي بنجاح!',
        softdelfailed: 'فشل الحذف المنطقي!',
        erroduringsoftdel: 'خطأ أثناء الحذف المنطقي!',
        permamatdelsuc: 'تم الحذف النهائي بنجاح!',
        permantdelfailed: 'فشل الحذف النهائي!',
        errorduringperdel: "خطأ أثناء الحذف النهائي!",
        taskrecallcompletesuc: 'تم استرجاع المهمة بنجاح!',
        taskrecallfailed: 'فشل استرجاع المهمة!',
        erroduringtaskrecall: 'خطأ أثناء استرجاع المهمة!',
        attachmentismand: 'المرفق إلزامي!',
        onlypdfimgallowed: ' يُسمح فقط بملفات PDF والصور.',
        workflowmodule: 'وحدة سير العمل غير متاحة على الأجهزة المحمولة. يرجى استخدام جهاز كمبيوتر مكتبي أو جهاز لوحي للمتابعة.',
        Attachment: 'المرفق ',
        viewattachment: ' عرض المرفق',
        selectedtasknotassinged: 'المهام المحددة غير مخصصة ',
        Inactive: 'غير نشط ',
        aresurewantodeleterule: 'هل أنت متأكد أنك تريد حذف القاعدة؟',
        Assigning: 'جاري التعيين ',
        Saving: 'جاري الحفظ',
        Requesting: 'جاري الطلب ',
        enterextendeddate: 'أدخل التاريخ الممتد',
        targetoutstandingamtbyextdate: 'المبلغ المستحق المستهدف حسب التاريخ الممتد',
        Comments: 'تعليقات ',
        No: 'لا ',
        aresurewanttodeleterecord: 'هل أنت متأكد أنك تريد حذف السجل؟',
        downladreport: 'تنزيل التقرير',
        transferto: 'تم التحويل إلى',
        nometerdetailfound: 'لم يتم العثور على تفاصيل العداد للرمز الشريطي',

        loadingmeterdetail: 'جاري تحميل تفاصيل العداد',
        Print: 'طباعة ',
        ucantaddmorethan6: `لا يمكنك إضافة أكثر من 6 أقساط`,
        Proceed: 'متابعة ',
        taskdetails: 'تفاصيل المهمة',
        viewexistingfile: 'عرض الملف الموجود',
        nofileuploaded: 'لم يتم تحميل أي ملف.',
        nooptionavailable: 'لا توجد خيارات متاحة',

        fetchingaccdetails: 'جاري جلب تفاصيل الحساب',
        workflowid: 'معرف سير العمل',
        pdflink: 'رابط PDF',
        selectefieldpreiview: ' معاينة الحقل المحدد',
        fieldname: 'اسم الحقل',
        fieldtype: 'نوع الحقل:',
        selectfield: 'ختر الحقل',
        selectinputtype: 'اختر نوع الإدخال',
        updateinputype: 'تحديث نوع الإدخال',
        uploadnewphoto: 'تحميل صورة جديدة',
        Open: 'فتح ',
        uploadnewdoc: 'تحميل مستند جديد',
        viewpdf: 'عرض PDF',
        dragandroptoupload: 'اسحب وأسقط للتحميل',
        aresurewantodeletefile: 'هل أنت متأكد أنك تريد حذف الملف؟',
        generatereport: 'إنشاء تقرير ',
        Reject: 'رفض ',
        Approve: ' موافقة ',
        loadingmorenotification: 'جاري تحميل المزيد من الإشعارات',
        nomorenotification: 'لا توجد إشعارات إضافية للتحميل',
        Pending: 'قيد الانتظار ',
        Task: 'مهمة ',
        Mandatory: 'إلزامي ',
        Fields: ' حقول ',
        Other: 'أخرى ',
        Back: ' رجوع ',
        thisactivitydoesnothavefield: 'لا تحتوي هذه النشاطات على حقول',
        subcategory: 'الفئة الفرعية',
        selectsubcategory: 'اختر الفئة الفرعية',
        addcategory: 'إضافة فئة +',
        deletetask: 'حذف المهام',
        dosoftdeletions: 'تنفيذ الحذف المؤقت',
        depermanatdeletions: 'تنفيذ الحذف الدائم  ',
        confirmdeletion: 'تأكيد الحذف',
        areusurewanttoallassinged: 'هل أنت متأكد أنك تريد جعل جميع المهام المعينة، قيد التقدم، والمعلقة نشطة؟',
        selectlocationmap: 'اختر الموقع على الخريطة',
        Loading: 'جاري التحميل',
        nowuserfound: 'لم يتم العثور على مستخدمين',
        addfield: 'إضافة حقول',
        updatefield: 'تحديث الحقول',
        enterworkflowname: 'أدخل اسم سير العمل',
        Elements: 'العناصر ',

        Report: 'تقرير ',
        editinputvalues: 'تعديل قيم الإدخال',
        addedvalidation: 'تم إضافة التحققات',

        deletefield: 'حذف الحقل',
        deletevalidation: 'حذف التحقق',
        validationcode: 'رمز التحقق',
        novalidationavailable: 'لا توجد تحققات متاحة',
        rusurewanttodeleteworkflow: 'هل أنت متأكد أنك تريد حذف سير العمل هذا؟',
        noversionavb: 'لا توجد نسخ متاحة',
        noreportdataavb: 'لا توجد بيانات تقرير متاحة',
        goback: 'العودة ',
        aresurewantodeleteemail: 'هل أنت متأكد أنك تريد حذف هذا البريد الإلكتروني؟',
        nofieldagentfound: 'لم يتم العثور على أي عملاء ميدانيين',
        Selected: 'تم التحديد',
        updatedon: 'تم التحديث في',
        tariff: 'التعرفة',
        Office: 'مكتب ',
        cancelupload: 'إلغاء الرفع ',
        Recall: 'أسترجاع ',
        notaskavbtounasign: ' لا توجد مهام متاحة لإلغاء التعيين',
        unassigntask: 'إلغاء تعيين المهمة',
        selectassigntounassign: 'اختر الأشخاص المراد إلغاء تعيينهم من المهام المحددة',
        allassign: 'جميع المعينين',

        confirmaction: 'تأكيد الأجراء ',
        areusure: 'هل تريد بالتأكيد حذف هذه المهمة؟ هذا الإجراء غير قابل للاسترجاع',
        totalcount: 'العدد الإجمالي',
        Processing: ' جارٍ المعالجة',
        currenOs: ' نظام التشغيل الحالي',
        updatedat: 'تم التحديث في',
        curros: 'الحالي غير المكتمل / الحالي المعلّق',
        lastupdateddate: 'تاريخ آخر تحديث',
        lastupdatedtime: 'وقت آخر تحديث',
        assingename: 'اسم المُكلّف / المُعيّن',
        finisheddate: ' تاريخ الانتهاء',
        fnishedtime: '-وقت الانتهاء',
        Unsuccessful: 'غير ناجح ',
        Success: ' ناجح  ',
        fileprocessingcancle: 'تم إلغاء معالجة الملف.',
        pleaseenteraccnumber: 'الرجاء إدخال رقم الحساب.',
        projmissingplzelc: 'المشروع مفقود. الرجاء اختيار مشروع.',
        addleastonelementto: 'أضف عنصرًا واحدًا على الأقل إلى الصفحة الحالية قبل الانتقال للصفحة التالية.',

        checkuremailotp: ' تحقق من بريدك الإلكتروني للحصول على رمز التحقق',
        taskcreatedsuc: 'تم إنشاء المهام بنجاح',
        taskunassingedsucc: 'تم إلغاء تعيين المهمة بنجاح!',
        norecordareavailable: 'لا توجد سجلات متاحة',
        failedtouploadfile: 'فشل رفع الملف',
        failtoupdaterule: ' فشل في تحديث القاعدة',
        startdateerror: 'لا يمكن أن يكون تاريخ البدء بعد تاريخ الانتهاء',
        anerror: 'حدث خطأ أثناء تعيين الأصول',
        errorsubmiting: 'خطأ في إرسال النموذج',
        ruleupdated: ' تم تحديث القاعدة بنجاح',
        failupdaterule: 'فشل في تحديث القاعدة',
        plzselectworkflow: 'الرجاء اختيار سير عمل قبل إضافة قاعدة',
        basicinfo: " معلومات أساسية",
        changeprofile: " تغيير الملف الشخصي",
        updateRule: 'تحديث القاعدة',
        newRule: ' قاعدة جديدة',
        assignedAll: ' الكل مُعيَّن',
        notAssignedAll: 'الكل غير مُعيَّن',
        LoadingGeo: ' جارٍ تحميل الأكواد الجغرافية',
        selectgeocode: ' اختر الكود الجغرافي',
        All: 'الكل',
        loadingtyoecodes: 'جارٍ تحميل أكواد الأنواع',
        selecttypecodes: 'ختر كود النوع',
        selectamount: 'اختر نطاق المبلغ',
        ok: 'موافق',
        addRule: ' إضافة قاعدة',
        addproject: 'إضافة مشروع',
        departmentname: 'اسم القسم',
        projectname: '  اسم المشروع',
        adddepartment: ' إضافة قسم',
        seeData: ' عرض البيانات',
        enterrecipt: 'أدخل المستلمين ',
        enterbcc: 'أدخل العناوين في خانة النسخة المخفية (Bcc)',
        entercc: ' خل العناوين في خانة النسخة الكربونية (Cc)',
        assignbyrule: ' التوزيع حسب القواعد',
        searchfieldAgent: ' البحث عن الموظفين الميدانيين',
        loadingtask: 'جاري تحميل تفاصيل المهمة',
        fieldagentAvgwork: 'متوسط وقت عمل الموظف الميداني',
        selectDash: 'ختر لوحة التحكم',
        selecttask: 'اختر حالة المهمة',
        selectStatus: '  اختر الحالة',
        SelectDateTime: 'اختر نطاق التاريخ والوقت',
        startdatetime: ' تاريخ ووقت البداية ',
        enddatetime: 'تاريخ ووقت النهاية',
        selectDateRange: ' اختر نطاق التاريخ',
        fieldAgentCLock: 'تسجيل دخول /خروج الموظف الميداني',
        selectusertpye: ' أختر نوع المستخدم',
        isClockin: 'هل  تم تسجيل الدخول',
        selectvehicle: 'أختر المركبة',
        vehicalid: ' رقم المركبة   ',
        OrganizationId: ' رقم المؤسسة',
        inuse: 'قيد الاستخدام ',
        id: ' رقم التعريف',
        selectAsset: 'أختر المورد ',
        showLatLog: "إظهار المهام التي تفتقد خطوط الطول/العرض",
        hidelatlog: " إخفاء المهام التي تفتقد خطوط الطول/العرض",
        createdatetime: "تاريخ ووقت الإنشاء ",
        taskCategory: " فئة المهمة ",
        mobileno: " رقم الهاتف",
        discardMessage: ' هل تريد حقاً المغادرة ؟ هذا الإجراء سيؤدي إلى الحفظ أو الإلغاء',
        viewinstallmentmsg: 'دخل رقم الحساب لعرض خطط الأقساط',
        optionalSelectedfield: ' حقول اختيارية',
        emailnotification: 'إشعارات البريد الإلكتروني',
        recievemeial: ' استلام إشعارات البريد الإلكتروني لتحديثات المهام والتذكيرات ',
        taskmangement: ' إدارة المهام',
        autoAssignTask: ' إسناد المهام تلقائياً',
        autoasigntaskto: 'إسناد المهام تلقائياً لأعضاء الفريق المتاحين',
        protectioninWorkflow: 'الحماية في سير العمل ',
        preventtaskprotected: ' منع التغييرات على المهام بعد أن تكون قيد التنفيذ',
        othersetting: ' إعدادات أخرى ',
        choselang: 'أختر اللغة الافتراضية للتطبيق',
        addmeail: ' إضافة بريد إلكتروني',
        email: " البريد الإلكتروني",
        notchartYet: 'لا تتوفر بيانات لعرضها في هذا المخطط بعد ',
        priorityLevel: 'مستوى الأولوية ',
        entername: "أدخل الأسم",
        Activities: "الأنشطة",
        basicField: "الحقول الأساسية",
        recent: "مؤخرًا",
        selectionfield: "حقل الاختيار",
        mediafield: "وسائل الاعلام والمجالات الخاصه ",
        items: "العناصر",
        Enable: "تمكين",
        disable: "تعطيل",
        comapletedDate: "تاريخ الإكمال",
        taskId: "معرف المهمة",
        noproject: "لا توجد مشاريع",
        nodepartment: " لا توجد أقسام",
        noactivity: " لا توجد أنشطة",
        splaignrule: "قاعدة المهام الخاصة",
        myprofile: "ملفي الشخصي",
        barChart: "مخطط شريطي",
        Piechart: " مخطط دائري",
        Radarchart: " مخطط الرادار",
        Linechart: "مخطط خطي",
        Areachart: "مخطط مساحي",
        OrganizationLogo: "شعار المنظمة",
        OrganizationName: "اسم المنظمة",

        Organizations: "المنظمات",
        ReportType: " نوع التقرير",
        ForInstallmentPlan: " لخطة التقسيط",
        WorkflowNames: " أسماء سير العمل",
        ReportLink: "رابط التقرير",
        RequestedAt: " تم الطلب في",
        Noguidelines: "لا توجد إرشادات متاحة",
        Deleteworkflowmsg:
            " هل تريد المغادرة حقًا؟ هذا الإجراء سيؤدي إلى حذف هيكل سير العمل الذي أنشأته",
        MandatoryFields: "لحقول الإلزامية",
        NonMandatoryFields: " الحقول غير الإلزامية",
        BulkUpload: "رفع جماعي",
        CreateandAssigne: "إنشاء وتعيين",
        AssetName: "اسم الأصل",
        UserId: "معرف المستخدم",
        FieldStaffList: "قائمة موظفي الميدان",
        SUBMISSION: "إرسال",
        NOT_COMPLETED: "غير مكتمل",
        HideCriteria: "إخفاء المعايير",
        NewCriteria: "إضافة معيار جديد",
        ActivityQuestions: "اختر أسئلة النشاط",
        FieldQuestion: "اختر سؤال الحقل",
        Select: "اختر",
        AddChart: "إضافة مخطط",
        DeleteDash: "هل أنت متأكد أنك تريد حذف لوحة المعلومات هذه؟",
        DeleteGraph: "هل أنت متأكد أنك تريد حذف هذا المقياس البياني؟",
        CreateDash: "إنشاء لوحة معلومات للنشاط",
        Role: "الدور",
        Activity: "النشاط",
        selectWorkflow: "اختر سير العمل",
        ActivityName: "اسم النشاط",
        SelectChart: "اختر مخطط",
        ViewChart: "عرض المخطط",
        RangeFilter: "مرشح نطاق التاريخ",
        selecrOrg: " يرجى اختيار منظمة",
        Page: "الصفحة",
        FieldId: "رقم تعريف موظف الميدان",
        FieldAgentName: "اسم موظف الميدان",
        Action: "إجراء",
        RemarkReq: "الملاحظات مطلوبة",

        adCustSupport: "إضافة دعم العملاء",
        Clone: "نسخ",
        SpecialRc: "خاص RC",
        InteractiveRc: "تفاعلي RC",
        Viewinstallment: "عرض القسط ",
        createInstallment: "إنشاء خطة تقسيط",
        CustomerId: "معرف العميل",
        NoOfinstallment: "عدد الأقساط",
        advancepayamt: "مبلغ الدفع المقدم",
        advDate: " تاريخ الدفع المقدم",
        custDetail: "تفاصيل العميل",
        instalDetail: "تفاصيل القسط",
        firstInstDate: "تاريخ أول قسط",
        clrPreview: "مسح المعاينة",
        prevPlan: " معاينة الخطة",
        submitRc: "RC إرسال  ",
        AfterAdv: "المستحقات بعد دفع المقدم",
        currentOut: "المستحقات الحالية",

        Amount: "المبلغ ",
        Notes: "الملاحظات ",
        Latitude: "خط العرض  ",
        Longitude: " خط الطول ",
        selectFieldAget: " اختيار الموظف ميداني",
        planId: "رقم الخطة",
        planActive: "الخطة نشطة",
        planCreated: "تم إنشاء الخطة",
        outstaningAmt: "المبلغ المستحق",
        Advamt: "مبلغ المقدم",
        AdvDate: " تاريخ دفع المقدم",
        firstInsDate: "تاريخ أول قسط",
        noOfInst: " عدد الأقساط",
        activeInst: "الأقساط النشطة",
        DetailId: "رمز التفاصيل",
        PaymentId: "رمز الدفع",
        PayAmt: "مبلغ الدفع",
        payDate: "تاريخ الدفع",
        Status: "الحالة ",
        PayPrev: "معاينة الدفع",
        OutAfteAdv: "المبلغ المستحق بعد دفع المقدم ",
        CurrentOut: "المبلغ المستحق الحالي ",
        NoinstAvlble: "لا توجد أقساط متاحة",
        title: "حلول إدارة المهام من بلوفيلد ",
        userEmail: "اسم المستخدم / عنوان البريد الإلكتروني",
        remember: "تذكرني",
        forgetpass: "نسيت كلمة المرور",
        Login: "تسجيل الدخول ",
        pressEnter: "اضغط إدخال لإضافة أرقام حسابات متعددة",
        typeEnter: "اكتب رقمًا واضغط إدخال",

        payDetail: "تفاصيل الدفع",
        cretDate: "تاريخ الإنشاء",
        inactiveplane: "خطط التقسيط غير النشطة",
        instplanDetail: "تفاصيل خطة التقسيط",
        loogoutMsg: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
        Logout: " تسجيل الخروج",
        support: "دعم العملاء",
        supporttooltip: "نظام الدعم  RC",
        powerbidashboard: "لوحة معلومات PowerBI",
        installment: "خطة التقسيط",
        password: "كلمة المرور",
        downloadPdf: "تحميل PDF",
        noDatavb: "لا تتوفر بيانات",
        viewValidation: "عرض التحقق من الصحة",
        refresh: " تحديث الجدول",
        discard: "إلغاء",
        Confirm: "تأكيد",
        datefilterforchart: "مرشح التاريخ للمهام المكتملة",
        updatetaskdetail: "تحديث تفاصيل المهمة",
        completedTaskCount: "عدد المهام المكتملة  ",
        taskpriority: "أولوية ",
        taskstatus: "حالة المهمة",
        request: "طلب",
        usercount: "أعداد المستخدمين",
        listvbiew: "عرض قائمة المهام",
        addbtn: "يضيف",
        unassignn: "إلغاء التعيين",
        assingTask: "تعيين المهام",
        date: "التاريخ",
        from: "من",
        to: "إلى",
        apply: "تطبيق",
        previous: "السابق",
        next: "التالي",
        profile: "حساب تعريفي",
        uploadSheet: " تحميل الورقة",

        //notification
        notification: "إشعار",
        allnotification: "كل الإخطار",
        //dashbord
        deletDashbord: "حذف لوحة المعلومات",
        workflow: "سير العمل",
        dashboard: "لوحة القيادة",
        userdashboard: "لوحة تحكم المستخدم",
        activitydashboard: "لوحة معلومات النشاط",
        admin: "مسؤول ",
        office_user: "مستخدمي المكتب",
        field_agent: "موظفين الميدان",
        dashboardName: "اسم لوحة المعلومات",
        addnewDashboard: "إضافة لوحة تحكم جديدة",
        chartMessage: "حدد لوحة المعلومات لعرض المخططات",

        dashboardtolltip:
            "لوحة المعلومات، عرض وإدارة نظرة عامة على لوحة المعلومات الخاصة بك",
        usertooltip: "المستخدمون، إدارة حسابات المستخدمين والأدوار",
        asset: "إدارة الأصول",
        assettooltip: "الأصول وعرض وإدارة الأصول الخاصة بك",
        config: "قواعد التعيين",
        configtooltip:
            "التكوين وإدارة قواعد التعيين والقواعد المخصصة وقواعد الإكمال",
        task: "إدارة المهام",
        tasktooltip: "إدارة المهام، إدارة المهام والواجبات الخاصة بك، والحذف",
        acchistory: "سجل الحساب",
        accReportsCenter: "مركز الحسابات والتقارير",
        historytooltip: "سجل الحساب، عرض تاريخ المهام المكتملة",
        workflowe: "سير العمل",
        workflowtooltip: "سير العمل، إدارة سير العمل الخاص بك، المبادئ التوجيهية",
        worklog: "سجل العمل",
        worklogtooltip:
            "سجل العمل، عرض وإدارة سجلات العمل الخاصة بك، تصدير تقرير Excel، تصدير PDF",

        security: "حماية",
        securitytooltip: "الأمان، إدارة إعدادات الأمان",
        report: "التقارير",
        reportooltip: "التقارير، طلب التقرير، التحقق من حالة التقارير",
        roleManagement: "إدارة الأدوار",
        roleManagementtooltip: "إدارة الأدوار والصلاحيات",
        createRole: "إنشاء دور",
        updateRole: "تحديث الدور",
        deleteRole: "حذف الدور",
        roleName: "اسم الدور",
        confirmDeleteRole: "هل أنت متأكد أنك تريد حذف هذا الدور؟",
        noRolesFound: "لا توجد أدوار",
        org: "منظمة",
        orgtooltip: "التنظيم، إدارة المنظمة",
        stock: "إدارة المخزون",
        stocktoooltip: "إدارة المخزون، تحديث تفاصيل المخزون، تنزيل التقرير",
        //USER
        addUser: "إضافة مستخدم",
        searchusername: "البحث حسب اسم المستخدم...",
        searchareacode: "البحث عن طريق رمز المنطقة...",
        userType: "نوع المستخدم",
        user: "مستخدم",
        edit: "يحرر",
        userlist: "إدارة المستخدمين ",

        userdetail: "تفاصيل المستخدم",
        previllage: "الامتيازات",
        cancle: "إلغاء",
        updateuser: "تحديث المستخدم",
        add: "إضافة مستخدم",
        username: "اسم المستخدم",

        selectOrg: "حدد المنظمة",
        areCode: "كود المنطقة",
        addeditActivity: "إضافة/تعديل النشاط ",
        addnewlabel: "إضافة/تحرير التكوين     ",
        addEdituser: "إضافة/تحرير مستخدم",
        canasset: "يمكن الوصول إلى إدارة الأصول",
        uservisibility: "رؤية المستخدم",
        modifyguidline: "تعديل المبادئ التوجيهية",
        createDashboar: "إنشاء لوحة المعلومات",
        addeditleader: "إضافة/تحرير لوحة المتصدرين",

        canTaskManage: "يمكن الوصول إلى إدارة المهام",
        canAddEditProtectedAccount: "يمكن إضافة/تحرير الحساب المحمي",
        canAddEditInventory: "يمكن إضافة/تحرير إدارة المخزون",

        //SETTING
        general: "عام",
        save: "حفظ التغييرات",
        setting: "إعدادات",
        langSetting: "إعدادات اللغة",
        colormode: "وضع اللون",
        light: "ضوء",
        dark: "مظلم",
        highcontrast: "التباين العالي",
        lang: "لغة",
        toursetting: "إعداد الجولة",
        stoptour: "توقف الجولة",
        starttour: "ابدأ الجولة",
        custommarker: "علامة مخصصة",
        all: "الجميع",
        assigned: "مهام",
        active: "نشيط ",
        progress: "قيد التنفيذ",
        completed: "مكتمل",
        onhold: "في الانتظار",

        //ASSET
        vehical: "مركبة",
        Inventory: "جرد",
        exportreport: "تصدير تقرير",
        addVehical: "أضف مركبة جديدة",
        addAsset: "إضافة أصول جديدة",
        search: "يبحث",

        vehicalType: "نوع المركبة",
        vehicalAssign: "المكلف بالمركبة",
        searchbyId: "البحث بالمعرف...",
        assetType: "نوع الأصول",
        assetAssign: "المكلف بالأصول",
        addnewasset: "إضافة تأكيد جديد",
        assetId: "معرف الأصل",
        agentAssigned: "الوكيل المعين",
        assetStatus: "حالة الأصل",
        updateAsset: "تحديث الأصول",
        Update: "تحديث",
        updateVehical: "تحديث المركبة",

        //CONFIGURATION
        complitionrule: "قواعد الإكمال",
        assignment: "قواعد التعيين",
        customerule: "المتغيرات المخصصة",
        rulename: "اسم القاعدة",
        assignTo: "تعيين ل",
        activedeactive: "نشط / غير نشط",
        criteria: "معايير",
        submit: "إرسال",
        update: "تحديث",
        norule: "لا مزيد من القواعد للتحميل",
        icon: "رمز",
        createrule: "إنشاء قاعدة جديدة",
        addNewRule: "إضافة قاعدة جديدة",

        multiSelect: "تحديد متعدد",
        smartAssign: "التعيين الذكي",
        FieldStaff: "الموظفين الميدانيين",
        Location: "موقع",
        MapStatus: "حالة الخريطة",
        fieldAgent: "الموظف الميداني",
        allFieldAgents: "جميع الموظفين الميدانيين",
        createNewTask: "إنشاء مهمة جديدة",
        importCSV: "  تحميل المهمة",
        mapview: "عرض الخريطة",
        createTask: "إنشاء مهمة جديدة",
        download: "تحميل",
        deleteAllRecord: "حذف كافة السجلات",
        assign: "تعيين",

        reassign: "إعادة التعيين",
        alert: "تنبيه مرسل",
        delete: "حذف ",
        priority: "أولوية",
        status: "الحالة ",
        searchbycode: "البحث عن طريق رمز المنطقة..",
        selectAssign: "حدد المكلف",
        downloadtask: " تنزيل تقرير المهام",
        seectallactivty: "حدد كل الأنشطة",
        selectpartcular: " نشاط معين محدد",
        selectMsg: "الرجاء تحديد نشاط للمتابعة.",
        createnewtask: "إنشاء مهمة جديدة",
        cancel: "إلغاء",
        create: "إنشاء",

        //import csv
        DragDetail: "قم بسحب وإسقاط ملف CSV الذي يحتوي على جميع تفاصيل المهمة",
        sizeMsg: "الحد الأقصى لحجم الملف: 15 ميجابايت",
        import: "CSV إستيراد ملف",
        uploadfile: "تحميل قائمة المهام",
        uploadby: "تم الرفع بواسطة",
        uploaddate: "تاريخ التحميل",
        uploadtime: "وقت التحميل (24 ساعة)",

        //taskd etail
        taskdetail: "تفاصيل المهمة",
        taskhistory: "سجل المهام",
        nohistory: "لا يوجد سجل مهام متاح.",
        more: "جارٍ تحميل المزيد من سجل المهام...",

        //task hisotry
        enteraccno: "أدخل رقم الحساب",
        reset: "إعادة تعيين",
        submitting: "جارٍ التقديم..",
        accDetail: "تفاصيل الحساب :-",
        accnumber: "رقم الحساب",
        area: "المنطقة",
        areacode: "رمز المنطقة",
        latitude: "خط العرض",
        longitude: "خط الطول",
        importdb: "استيراد قاعدة البيانات الرئيسية",
        exportData: "إصدار البيانات",
        downloading: "جاري التحميل...",
        viewGuideline: "عرض الإرشادات",
        createWorkflow: "إنشاء سير عمل جديد",
        guidline: "المبادئ التوجيهية",
        noworkflow: "لا توجد مسارات عمل متاحة",
        //worklog
        Scheduleemail: "جدولة تقرير البريد الإلكتروني",
        export: "إصدار التقارير",
        pdf: "إصدار الملفاتPDF",
        todo: "مهام",
        loading: "جاري تحميل المزيد من سجل العمل...",
        nomore: "لا مزيد من سجل العمل للتحميل",
        name: "الحساب المحمي",
        createacc: "إنشاء حساب جديد",
        editacc: "تحرير الحساب المحمي",
        createproacc: "إنشاء حساب محمي",
        permanent: "الحماية الدائمة",
        protectionValid: "صلاحية الحماية حتى",
        createdBy: "تم إنشاؤها بواسطة",
        accProtection: "حماية الحساب لجميع الأنشطة",
        accno: "رقم الحساب",
        remark: "ملاحظات",

        enterremark: "أدخل ملاحظاتك هنا",
        updatemeterDEtail: "تحديث تفاصيل العداد",
        downloadsheet: "تحميل الورقة",
        uploadinventory: "تحميل ورقة الجرد",
        reportType: "نوع التقرير",
        form: "طلب تقرير",
        startDate: "تاريخ البدء",
        endDate: "تاريخ الانتهاء",
        orglist: "قائمة المنظمات",
        createOrg: " إنشاء منظمة",
        noOrg: "لا توجد بيانات المنظمة المتاحة.",
        rows: "عدد الصفوف في كل صفحة ",
        orgname: "اسم المنظمة",
        img: "تحميل الشعار",
        creating: "جارٍ الإنشاء...",
        updateOrg: "تحديث المنظمة",
        Updating: "جارٍ التحديث...",
        nolog: "لا يوجد شعار",
        number: "رقم",
        geoCodes: "رموز جغرافية مختارة",
        typeCodes: "رموز النوع المحددة",
        amountRange: "نطاق المبلغ المحدد",
        assignAll: "تعيين الكل",
        default: "تقصير",
        select: " حدد النشاط",
        selecteOrgName: " اختر المنظمة",
        selectsubactivty: " حدد النشاط الفرعي ",

        emailreport: "جدولة تقرير البريد الإلكتروني",
        selectactivity: "اختر النشاط:",
        recipients: "المستلمون",
        bcc: "نسخة مخفية الوجهة",
        cc: "نسخة",
        sendreport: "إرسال التقرير المقرر",
        senddashboard: "إرسال لوحة المعلومات:",
        shedulesend: "جدول الإرسال:",
        daily: "يوميًا",
        weekly: "أسبوعي",
        monthly: "شهريا",
        send: "يرسل",
        reportbtn: "طلب تقرير",


        stockmanag: "إدارة المخزون",
        fromdate: "من التاريخ",
        todate: "إلى التاريخ",
        metercode: "الباركود الخاص بالعداد",
        location: "إلى الموقع",
        filter: "تطبيق الفلترة",

        visitTime: "وقت الزيارة ",
        visitDate: "تاريخ الزيارة ",
        nopdfavb: "ملف PDF غير متاح",

        // login
        Utilities: "المرافق و",
        TasksManagementSolutions: "حلول إدارة المهام",
        UsernameEmailAddress: "اسم المستخدم / عنوان البريد الإلكتروني",
        RememberMe: "تذكرنى",
        ForgotPassword: "هل نسيت كلمة السر؟",
        assetBarCode: "(رمز الاستجابة للأصول (الباركود",
        dragAndDropDocuments: "اسحب وأفلت المستندات",
        viewDocuments: "عرض المستندات",
        uploadedDocument: "المستند المُحمّل",
        maxFileSize5MB: "الحد الأقصى لحجم الملف: 5 ميغابايت",
        browse: "تصفح",
        description: "الوصف",
        kilometer: "كيلومتر",
        noAccountDetialsAvailable: "لا توجد تفاصيل حساب متاحة",
        enterAccSubmitViewDetails: "أدخل رقم الحساب واضغط إرسال لعرض التفاصيل",
        uploading: "جارٍ التحميل",
        upload: "تحميل",
        addOrganization: "إضافة مؤسسة",
        addDepartment: "إضافة قسم",
        uploadOrganizationLogo: "تحميل شعار المؤسسة",
        successMessage:
            ".يرجى الانتظار! يتم حالياً تحميل الملف. قد يستغرق ذلك بعض الوقت، وبمجرد اكتمال التحميل بنجاح، ستتلقى رسالة تأكيد",
        fullName: "الاسم الكامل",
        department: "القسم",
        project: "المشروع",
        profileImage: "صورة الملف الشخصي",
        vehicleId: "معرف المركبة",
        vehicleKM: "(KM) ممشى المركبة",
        vehicleAssinged: "المركبة المعينة",
        editPrivileges: "صلاحيات التعديل",
        source: "المصدر",
        thecustomcodewarningmessage:
            "لم يتم إضافة لون العلامة المخصصة، الرجاء الاختيار من القائمة أدناه!!",
        selectWorkflowFirst: "يرجى اختيار سير العمل أولاً",
        makerColor: "تم حفظ ألوان العلامات بنجاح",
        failedtoSaveMakerColor: "فشل في حفظ ألوان العلامات",
        permanentProtection: "الحماية الدائمة لن تحتوي على تاريخ انتهاء",
        noRecordAvailable: "لا توجد سجلات متاحة",
        reportGenerating: "جاري توليد التقرير...",
        mediumPriority: "أولوية متوسطة",
        highPriority: "أولوية عالية",
        lowPriority: "أولوية منخفضة",
        accountProtection: "حماية الحساب",
        clockIn: "تسجيل الحضور",
        clockOut: "تسجيل الانصراف",
        showAsFilter: "إظهار كمرشح",
        English: "إنجليزي",
        Urdu: "الأردية",
        Arabic: "عربي",
        History: "تاريخ",
        Heading: "رأس الموضوع",
        Name: "اسم",
        Email: "بريد إلكتروني",
        Phone: "الهاتف",
        Address: "عنوان",
        DatePicker: "منتقي التاريخ",
        TakePhoto: "التقط صورة",
        MultipleImages: "صور متعددة",
        Signature: "التوقيع",
        RadioButton: "زر الراديو",
        Checkbox: "خانة الاختيار",
        Dropdown: "اسقاط",
        Number: "رقم",
        Time: "وقت",
        LongText: "نص طويل",
        Barcode: "الباركود",
        wfElTooltipHeading: "استخدم هذا لإضافة عنوان.",
        wfElTooltipName: "أدخل الاسم للحقل.",
        wfElTooltipEmail: "أدخل عنوان بريد إلكتروني صالح.",
        wfElTooltipPhone: "أدخل رقم الهاتف.",
        wfElTooltipAddress: "أدخل العنوان.",
        wfElTooltipDate: "اختر تاريخاً من التقويم.",
        wfElTooltipPhoto: "ارفع صورة.",
        wfElTooltipMultiImage: "ارفع صوراً متعددة.",
        wfElTooltipSignature: "أضف توقيعاً.",
        wfElTooltipRadio: "اختر خياراً واحداً من بين عدة خيارات.",
        wfElTooltipCheckbox: "حدد خيارات متعددة إن أمكن.",
        wfElTooltipDropdown: "اختر خياراً من القائمة المنسدلة.",
        wfElTooltipNumber: "أدخل قيمة رقمية.",
        wfElTooltipTime: "اختر وقتاً محدداً.",
        wfElTooltipLongText: "أدخل نصاً تفصيلياً أو أوصافاً.",
        wfElTooltipBarcode: "امسح رمزاً شريطياً للإدخال.",
        wfElTooltipOcr: "التعرف الضوئي على الحروف.",
        wfElTooltipGps: "نظام تحديد المواقع العالمي.",
        workflowModalPreviewOptionsEmpty:
            "أضف الخيارات في منشئ النموذج لعرضها هنا.",
        NotificationSound: "صوت الإخطار",
        TestSound: "اختبار الصوت",
        Configurations: "التكوينات",
        TermsAndConditions: "الشروط والأحكام",
        DragDropTermsConditionFile: "اسحب وأفلِت ملف الشروط والأحكام",
        PrivacyAcceptance: "قبول الخصوصية",
        DragDropPrivacyAcceptanceFile: "اسحب وأفلِت ملف قبول الخصوصية",
        TermsandConditionPdf: "الشروط والحالة.pdf",
        view: "منظر",
        NoReportDataavailble: "لا توجد بيانات تقرير متاحة",
        UnexpectedResponseFormat: "تنسيق رد غير متوقع. يُرجى المحاولة مرة أخرى.",
        chooseFile: "اختر ملف",
        noFile: "لم يتم اختيار أي ملف",
        PasswordRequired: "كلمة المرور مطلوبة",
        PasswordMustBeAtLeast8Characters:
            "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
        IncludeDeletedRecords: "تضمين السجلات المحذوفة",

        pleaseFillAllFieldsBeforeSaving: "يرجى ملء جميع الحقول قبل الحفظ",
        ruleCreatedSuccessfully: "تم إنشاء القاعدة بنجاح",
        pleaseSelectFromDateToDate:
            'الرجاء تحديد كل من "من التاريخ" و"إلى التاريخ".',

        exportBtn: "تصدير",
        importBtn: "استيراد",
        addTaskBtn: "إضافة مهمة",
        attachProof: "إرفاق إثبات (PDF/صورة)",
        activityAnalytics: "تحليلات النشاط",
        analyticsStatusLabel: "الحالة",
        chartSelectFiltersHint:
            "اختر النشاط، الحالة والتواريخ لعرض المخطط",
        chartLoading: "جاري التحميل...",
        taskActions: "إجراءات المهمة",
        selectedLocation: "الموقع المحدد",
        drawnArea: "منطقة مرسومة",
        clearSelection: "مسح",
        clickMarkerForLocationDetails:
            "انقر على العلامة في الخريطة لعرض تفاصيل الموقع",
        taskDetailsSection: "تفاصيل المهمة",
        loadingTaskDetails: "جاري تحميل تفاصيل المهمة...",
        clickMarkerLoadTaskDetails:
            "انقر على العلامة لعرض تفاصيل المهمة",
        taskStatusSection: "حالة المهمة",
        availableAgents: "الوكلاء المتاحون",
        searchFieldAgentsPlaceholder: "ابحث عن الوكلاء الميدانيين...",
        noAgentsMatchSearch: "لا يوجد وكلاء مطابقون لبحثك",
        noAgentsAvailable: "لا يوجد وكلاء متاحون",
        loadingAgentsLabel: "جاري تحميل الوكلاء...",
        statusActiveLabel: "نشطة",
        statusInProgressLabel: "قيد التنفيذ",
        statusCompletedLabel: "مكتملة",
        statusAssignedLabel: "مُعيّنة",
        statusOnHoldLabel: "معلّقة",
        unassignedLabel: "غير معيّن",
        taskIdLabel: "معرّف المهمة",
        assigneeLabel: "المكلّف",
        completedCountSuffix: "مكتمل",
        tasksInDrawnAreaTitle: "مهام في المنطقة المرسومة",
        tasksListTitle: "مهام",
        centerApproxLabel: "المركز (تقريبي)",
        latLongUpperLabel: "خط العرض / الطول",
        agentUpperLabel: "الوكيل",
        activeTasksUpperLabel: "المهام النشطة",
        taskWord: "مهمة",
        tasksWord: "مهام",
        assignTaskCountVerb: "تعيين",
        taskSingular: "مهمة",
        tasksPlural: "مهام",
        onlineLabel: "متصل",
        offlineLabel: "غير متصل",
        showOnlineAgentsTitle: "عرض الوكلاء المتصلين",
        showOfflineAgentsTitle: "عرض الوكلاء غير المتصلين",
        onlyActiveTasksAssignableTitle:
            "يمكن تعيين المهام النشطة فقط",
        consNameEnglish: "اسم المستهلك (بالإنجليزية)",
        consNameArabic: "اسم المستهلك (بالعربية)",
        meterNoLabel: "رقم العداد",
        consumerTypeLabel: "نوع المستهلك",
        phoneLabel: "الهاتف",
        lastReadTypeLabel: "نوع القراءة الأخيرة",
        lastReadingLabel: "آخر قراءة",
        lastReadingDateLabel: "تاريخ آخر قراءة",
        averageLabel: "المتوسط",

        instalmentPlanNotExisting: "خطة التقسيط غير موجودة لرقم الحساب المحدد",
        remarksError: "حقل الملاحظات مطلوب",
        previewPlanError: "لقد واجهنا خطأ غير متوقع.",

        meterBarCode: "الباركود الخاص بالعداد",
        components: "عناصر",
        meterType: "نوع العداد",
        manufacturingYear: "سنة التصنيع",
        meterMake: "الشركة المصنعة للعداد",
        activationDate: "تاريخ التفعيل",
        batchNo: "رقم الدفعة",
        installationStatus: "حالة التثبيت",
        createBy: "تم إنشاؤها بواسطة",
        createdAt: "تم إنشاؤه في",
        simNo: "رقم الشريحة",
        ipAddress: "عنوان الملكية الفكرية",
        iccid: "iccid",
        apn: "apn",
        op: "مرجع سابق",
        balance: "توازن",
        simDetailUpdatedAt: "تم تحديث تفاصيل السيم في",
        transferredFrom: "منقول من",
        transferredTo: "نقل الى",
        DragYourElementsToSecondPageFromLeftPanel: ".أسحب العناصر من الصفحة الثانية من بين اللوحات اليمنى",
        Deactive: "غير نشط",
        Yes: "نعم",
        WhatDoYouWantExistingAccounts: "ماذا تريد أن تفعل بالحسابات الموجودة؟",
        updateAlreadyExistingAccountEntries: "تحديث إدخالات الحساب الموجودة بالفعل؟",
        createNewAccountEntries: "إنشاء إدخالات حساب جديدة؟",
        customerDetails: "تفاصيل إنشاء القسط",
        created_By: "تم إنشاؤه بواسطة",
        accountNo: "رقم الحساب",
        civilId: "معرف العميل",
        phoneNo: "رقم الهاتف",
        comment: "تعليق",
        employee: 'موظف', // employed id added by harshit vachhani
        subContract: 'العقد من الباطن', // subContract added by harshit vachhani
    },
    ur: {
        accountreportcenter: 'اکاؤنٹ اور رپورٹس سینٹر',
        PDF: "PDF",
        viewdetails: 'تفصیل دیکھیں',
        addnewvehicale: 'اپنی اثاثوں کی فہرست میں ایک نئی گاڑی شامل کریں۔',
        cancelandstay: 'منسوخ کریں اور صفحہ پر رہیں',
        confirmandlogout: 'تصدیق کریں اور لاگ آؤٹ کریں۔',
        welcome: 'خوش آمدید',
        welcomeback: 'دوبارہ خوش آمدید',
        editandudateasset: ' اثاثوں کی تفصیلات میں ترمیم اور اپ ڈیٹ کریں۔ ',
        assigntheselected: 'منتخب اثاثے فیلڈ سٹاف کو تفویض کریں۔',
        updatetherule: 'اصول کو اپ ڈیٹ کریں۔',
        submitherule: ' قاعدہ جمع کروائیں۔',
        addassignmentrule: ' تفویض کا اصول شامل کریں۔',
        savetherule: 'اصول کو بچائیں۔',
        addcompletionrule: ' تکمیل کا اصول شامل کریں۔',
        addcustomrule: ' حسب ضرورت اصول شامل کریں۔',
        assignallactiverules: 'تمام فعال قواعد تفویض کریں۔',
        addnewspecialassingmentrule: 'نیا خصوصی تفویض اصول شامل کریں۔',
        updatetherulewitjselectedpara: ' منتخب پیرامیٹرز کے ساتھ اصول کو اپ ڈیٹ کریں۔',
        createneweulwwithselected: ' منتخب پیرامیٹرز کے ساتھ نیا اصول بنائیں',
        cancelandclose: ' ڈائیلاگ باکس کو منسوخ اور بند کریں۔',
        addnewdashboardtooltip: ' ایک نیا ڈیش بورڈ شامل کریں (آپ ورک فلو کی بنیاد پر ڈیش بورڈ بنا سکتے ہیں)',
        processthenextstep: ' اگلے مرحلے پر عمل کریں۔',
        deletethedashboard: ' ڈیش بورڈ کو حذف کریں۔',
        createdashboardtooltip: ' ڈیش بورڈ بنائیں ',
        canceltheselectedchart: 'منتخب کردہ چارٹ بنائیں',
        applytheselecteddaterange: 'منتخب کردہ تاریخ کی حد کا فلٹر لگائیں۔',
        downloadfilterdate: ' فلٹر شدہ تاریخ کے ساتھ ڈاؤن لوڈ کریں۔',
        proceedwiththeaction: 'کارروائی کے ساتھ آگے بڑھیں۔',
        addnewproject: ' نیا پروجیکٹ شامل کریں۔',
        addnewdepartment: ' نیا شعبہ شامل کریں۔',
        addneworgnization: 'نئی تنظیم شامل کریں۔',
        updateorgnizations: ' تنظیموں کو اپ ڈیٹ کریں۔',
        savethechangesmadetomarkers: ' مارکر کے رنگوں میں کی گئی تبدیلیوں کو محفوظ کریں۔',
        updatethechangesmade: ' مارکر کے رنگوں میں کی گئی تبدیلیوں کو اپ ڈیٹ کریں۔',
        cancelanddiscardchanges: ' تبدیلیاں منسوخ اور رد کریں۔',
        requestthereport: ' رپورٹ طلب کریں۔',
        savetheprotectedaccount: ' محفوظ اکاؤنٹ کو محفوظ کریں۔',
        submitthereportrequest: ' رپورٹ کی درخواست جمع کروائیں۔',
        cancelandgoback: ' منسوخ کریں اور واپس جائیں۔',
        exportthexcelfilebasedon: 'فلٹر کی بنیاد پر ایکسل فائل کو ایکسپورٹ کریں۔',
        createaprotectedaccountwithpermanent: 'مستقل تحفظ کے ساتھ یا مخصوص مدت کے لیے ایک محفوظ اکاؤنٹ بنائیں',
        downloadthereportfortheselecte: ' منتخب تاریخ کی حد کے لیے رپورٹ ڈاؤن لوڈ کریں۔',
        uploadtheinventorysheet: ' انوینٹری ایکسل شیٹ اپ لوڈ کریں۔',
        downloadincentoryreport: 'انوینٹری رپورٹ ڈاؤن لوڈ کریں۔',
        applythesleectedfilters: 'منتخب کردہ فلٹرز لگائیں۔',
        uploadtheselectedexcelfile: 'منتخب ایکسل فائل اپ لوڈ کریں۔',
        createinstallmentplan: 'قسط کا منصوبہ بنائیں',
        generatepreviewfiter: '(پہلے پیش نظارہ بنائیں)',
        emiamount: '(EMI کی رقم بقایا رقم سے میل نہیں کھاتی)',
        finisheditinisntall: '(تدوین کی قسط ختم کریں) ',
        savechangesbeforesubmiting: ' (جمع کرانے سے پہلے تبدیلیاں محفوظ کریں)',
        totalemaiamount: '(کل EMI رقم منفی نہیں ہو سکتی)',
        userscancreateup: '(صارفین صرف 6 قسطیں بنا سکتے ہیں)',
        printpreviewtable: 'پیش نظارہ ٹیبل پرنٹ کریں۔',
        generatepreview: 'پیش نظارہ بنائیں',
        clearpreviewdata: ' پیش نظارہ ڈیٹا صاف کریں۔',
        submitforRccreation: ' RC تخلیق کے لیے جمع کروائیں۔',
        savethechagesmadeto: ' ادائیگی کی رقم میں کی گئی تبدیلیوں کو محفوظ کریں۔',
        editthepaymentamount: 'ادائیگی کی رقم میں ترمیم کریں۔',
        submitspecialRc: ' خصوصی RC جمع کروائیں۔',
        printinstallmentdetails: 'قسط کی تفصیلات پرنٹ کریں۔',
        proceedwithdeleaction: 'حذف کرنے کی کارروائی کے ساتھ آگے بڑھیں۔',
        deletetheselectedtask: ' منتخب کردہ کام کو حذف کریں۔',
        unassignntheseledtask: ' منتخب کردہ کاموں کو غیر تفویض کریں۔',
        reassigntheselectedtask: ' منتخب کردہ کاموں کو دوبارہ تفویض کریں۔',
        assigntheselectedtask: ' منتخب کردہ کام تفویض کریں۔',
        multiselecte: 'ملٹی سلیکٹ',
        addemailenablrnotifi: 'ای میلز شامل کریں، اطلاعات کو فعال کریں، اور دیگر ترتیبات کو ترتیب دیں۔',
        donwloadthetaskrecordin: 'منتخب کردہ سرگرمی یا تمام سرگرمیوں کی بنیاد پر ایکسل میں ٹاسک ریکارڈ ڈاؤن لوڈ کریں۔',
        createtaskbulk: 'ایک نیا ٹاسک بنائیں، تخلیق کریں اور تفویض کریں، یا بلک ٹاسک اپ لوڈ کریں۔',
        uploadthetasksheet: 'ٹاسک شیٹ اپ لوڈ کریں۔',
        assingtaskbasedonselectedrules: 'منتخب قواعد کی بنیاد پر کام تفویض کریں۔',
        reassigningprocess: 'دوبارہ تفویض کرنا جاری ہے۔',
        reassingselectedtasktochosen: 'منتخب کردہ کاموں کو منتخب فیلڈ ایجنٹوں کو دوبارہ تفویض کریں۔',
        assingtaskbasedonselectedrule: 'منتخب قواعد کی بنیاد پر کام تفویض کریں۔',
        reassinginginprocess: 'دوبارہ تفویض کرنا جاری ہے۔',
        reassignselectedtasktochosenfield: 'منتخب کردہ کاموں کو منتخب فیلڈ ایجنٹوں کو دوبارہ تفویض کریں۔',
        unassignselectedassingeesfromtask: 'منتخب کردہ تفویض کردہ افراد کو کاموں سے غیر تفویض کریں۔',
        savetheupdateddatacompleted: 'مکمل شدہ کاموں کے لیے اپ ڈیٹ کردہ ڈیٹا کو محفوظ کریں۔',
        gobacktheprivious: 'محفوظ کیے بغیر پچھلی اسکرین پر واپس جائیں۔',
        resetthecompletiondata: 'کام کی تکمیل کے ڈیٹا کو دوبارہ ترتیب دیں۔',
        closewithoutsavingchnages: 'تبدیلیاں محفوظ کیے بغیر بند کریں۔',
        savechangesmadetothefield: 'فیلڈ میں کی گئی تبدیلیوں کو محفوظ کریں۔',
        viewworkflowguidlines: 'ورک فلو کے رہنما خطوط دیکھیں',
        createnewworkflows: 'ایک نیا ورک فلو بنائیں',
        selectorgtocreateaworkflow: 'ورک فلو بنانے کے لیے ایک تنظیم منتخب کریں۔',
        scheduleemail: 'ای میل شیڈول کریں۔',
        exporttheexcelfilebasedonfilters: 'فلٹرز کی بنیاد پر ایکسل فائل کو ایکسپورٹ کریں۔',
        exportpdfbasedonfilters: 'فلٹرز کی بنیاد پر پی ڈی ایف فائل کو ایکسپورٹ کریں۔',
        downloadpdfbasedonfilters: 'فلٹرز کی بنیاد پر پی ڈی ایف ڈاؤن لوڈ کریں۔',
        savechangesforprofile: 'پروفائل کے لیے تبدیلیاں محفوظ کریں۔',
        requestonewreport: 'ایک نئی رپورٹ کی درخواست کریں۔',
        createamanualtask: 'ایک دستی کام بنائیں',
        createandassingtasktofield: 'فیلڈ ایجنٹ کو کام بنائیں اور تفویض کریں۔',
        closethedialogbox: 'ڈائیلاگ باکس بند کریں۔',
        gobacktomapmandotoryfield: 'لازمی فیلڈز کے نقشے پر واپس جائیں۔',
        submitmappeddataandstartupload: 'میپ شدہ ڈیٹا جمع کرائیں اور اپ لوڈ شروع کریں۔',
        procestomapnonmdaotry: 'غیر لازمی فیلڈز کا نقشہ بنانے کے لیے آگے بڑھیں۔',
        gobacktotaskpriority: 'کام کی ترجیحی انتخاب پر واپس جائیں۔',
        proceestomapmadatory: 'لازمی فیلڈز کا نقشہ بنانے کے لیے آگے بڑھیں۔',
        gobackprivousscren: 'محفوظ کیے بغیر پچھلی اسکرین پر واپس جائیں۔',
        addmultipleaccount: 'متعدد اکاؤنٹ نمبرز شامل کریں اور فیلڈ ایجنٹس کو کام تفویض کریں۔',
        selectatleast: 'تفویض کرنے کے لیے کم از کم ایک فیلڈ ایجنٹ منتخب کریں۔',
        assingmentinprocess: 'اسائنمنٹ جاری ہے۔',
        assingselectedtasktochosen: 'منتخب کردہ کاموں کو منتخب فیلڈ ایجنٹوں کو تفویض کریں۔',
        recallassingedtask: 'صارفین سے تفویض کردہ کاموں کو یاد کریں۔',
        deleterecordfrom: 'صارفین سے تفویض کردہ کاموں کو یاد کریں۔',
        donwloastheuplodedexcel: 'اپ لوڈ کردہ ایکسل فائل ڈاؤن لوڈ کریں۔',
        uploasthexcelfile: 'منتخب سرگرمی کے لیے ایکسل فائل اپ لوڈ کریں۔',
        savethechanges: 'تبدیلیاں محفوظ کریں۔',
        diacardchanges: 'تبدیلیوں کو مسترد کریں۔',
        proceedtomapnonmdfield: 'غیر لازمی فیلڈز کا نقشہ بنانے کے لیے آگے بڑھیں۔',
        submitthemapedcol: 'میپ شدہ کالم جمع کریں اور ڈیٹا اپ لوڈ کریں۔',
        uploadtheslectedfile: 'منتخب فائل کو اپ لوڈ کریں۔',
        uploadtheaccountexcel: 'اکاؤنٹس ایکسل شیٹ کو ماسٹر ڈیٹا بیس میں اپ لوڈ کریں۔',
        clearalldata: 'تمام ڈیٹا صاف کریں۔',
        fetchtheaccounthistory: 'درج کردہ اکاؤنٹ نمبر کے لیے اکاؤنٹ کی تاریخ حاصل کریں۔',
        donwlaodthetaskreportinpdfformat: 'ٹاسک رپورٹ کو پی ڈی ایف فارمیٹ میں ڈاؤن لوڈ کریں۔',
        editandupdateuserdetail: 'صارف کی تفصیلات میں ترمیم اور اپ ڈیٹ کریں۔',
        saveandcreateuser: 'محفوظ کریں اور صارف بنائیں',
        donotsavechangesgoback: 'تبدیلیاں محفوظ نہ کریں اور واپس جائیں۔',
        addauserassingroles: 'صارف کو شامل کریں اور کردار یا مراعات تفویض کریں۔',
        previewcurrentworkflowlayout: 'موجودہ ورک فلو لے آؤٹ اور فیلڈز کا جائزہ لیں۔',
        submitworkflow: 'ورک فلو جمع کروائیں۔',
        pleaseselectatleastonefild: 'براہ کرم کم از کم ایک فیلڈ بطور رپورٹ منتخب کریں۔',
        plzmakesuretosetauique: 'براہ کرم کلوننگ سے پہلے ایک منفرد ورک فلو کا نام سیٹ کرنا یقینی بنائیں',
        updatetheworkflowiwth: 'تازہ ترین تبدیلیوں کے ساتھ ورک فلو کو اپ ڈیٹ کریں۔',
        addnewvalidation: 'ایک نئی توثیق شامل کریں۔',
        closewithoutsavingchanges: 'تبدیلیاں محفوظ کیے بغیر بند کریں۔',
        viewwxistinfcalidation: 'موجودہ توثیق دیکھیں',
        savechangesmadetovalidation: 'توثیق میں کی گئی تبدیلیوں کو محفوظ کریں۔',
        discarchangesandexit: 'تبدیلیاں رد کریں اور باہر نکلیں۔',
        savetheupdateddata: 'مکمل شدہ کاموں کے لیے اپ ڈیٹ کردہ ڈیٹا کو محفوظ کریں۔',
        addselectefield: 'رپورٹ میں منتخب فیلڈز شامل کریں۔',
        gotonextpage: 'اگلے صفحے پر جائیں۔',
        gotopreviouspage: 'پچھلے صفحے پر جائیں۔',
        refeshreportlist: 'رپورٹ کی فہرست کو تازہ کریں۔',
        gobackpreviouspage: 'پچھلے صفحے پر واپس جائیں۔',
        requestreporbasedonfilter: 'فلٹرز پر مبنی رپورٹ کی درخواست کریں۔',
        filteredReports: 'فلٹر شدہ رپورٹس',

        failedtoloadruledata: 'اصول کا ڈیٹا لوڈ کرنے میں ناکام۔ براہ کرم help@blufield.net پر رابطہ کریں۔',
        pleaseSelectLeastAssetBeforeAssigning:
            "براہ کرم تفویض کرنے سے پہلے کم از کم ایک اثاثہ منتخب کریں۔",
        plzselectfieldagent: 'براہ کرم فیلڈ ایجنٹ کو منتخب کریں۔',
        assetsucassigned: 'اثاثے کامیابی کے ساتھ تفویض کیے گئے۔',
        assetsfailedassigned: 'اثاثے تفویض کرنے میں ناکام',
        logout: 'کامیابی سے لاگ آؤٹ ہو گیا۔',
        rulecreated: 'اصول کامیابی کے ساتھ بنایا گیا۔',
        unexpectederroroccured: 'فارم جمع کرانے میں خرابی۔ براہ کرم help@blufield.net پر بلوفیلڈ سپورٹ سے رابطہ کریں۔ ',
        plzselworkflow: 'براہ کرم معیار شامل کرنے سے پہلے ایک ورک فلو منتخب کریں۔',
        ruledeleted: 'اصول کامیابی کے ساتھ حذف ہو گیا۔',
        failedelrule: 'اصول کو حذف کرنے میں ناکام۔',
        PleaseSelectWorkflowBeforeAddingRule:
            "براہ کرم کوئی اصول شامل کرنے سے پہلے ایک ورک فلو منتخب کریں۔",
        plzfillallfield: 'براہ کرم جمع کرانے کے لیے تمام لازمی فیلڈز کو پُر کریں۔',
        failtoloadasign: 'اسائنمنٹ رولز لوڈ کرنے میں ناکام۔ براہ کرم help@blufield.net سے رابطہ کریں۔',
        failedtoassign: 'تمام اصول تفویض کرنے میں ناکام۔ براہ کرم help@blufield.net پر رابطہ کریں۔',
        OnClickTheOldAssignmentRuleDisabled:
            "کلک کرنے پر، اسائنمنٹ کا سابقہ ​​اصول غیر فعال ہو جائے گا۔",
        invalideruleid: 'غلط اصول ID۔',
        plzselfield: "براہ کرم ایک فیلڈ ایجنٹ منتخب کریں۔",
        nopermission: 'آپ کے پاس یہ صفحہ دیکھنے کے لیے ضروری اجازتیں نہیں ہیں۔ براہ کرم help@blufield.net پر رابطہ کریں۔ ',
        plzselectorg: 'براہ کرم ایک تنظیم منتخب کریں۔',
        somthingwentwrong: 'کچھ غلط ہو گیا!. براہ کرم help@blufield.net سے رابطہ کریں۔',
        excelisdownloading: 'ایکسل فائل ڈاؤن لوڈ ہو رہی ہے…',
        norecordfound: 'کوئی ریکارڈ نہیں ملا۔',
        anerroroccurred: 'رپورٹ ڈاؤن لوڈ کرتے وقت ایک خرابی پیش آگئی۔ براہ کرم help@blufield.net سے رابطہ کریں۔',
        orgaddedsuc: 'تنظیم کامیابی کے ساتھ شامل ہو گئی۔',
        errorcreatingorg: 'تنظیم بنانے میں خرابی۔ براہ کرم help@blufield.net سے رابطہ کریں۔',
        failstofetchorg: 'تنظیم کا ڈیٹا حاصل کرنے میں ناکام۔',
        orgupdated: 'تنظیم کا ڈیٹا حاصل کرنے میں ناکام۔',
        allfieldarerequired: 'تمام فیلڈز درکار ہیں۔',
        reportreqsuc: 'رپورٹ کامیابی کے ساتھ طلب کر لی گئی۔',
        errorequestreport: 'رپورٹ کی درخواست کرنے میں خرابی۔',
        addremark: 'ایک تبصرہ شامل کریں!',
        protectedAcccreated: 'محفوظ اکاؤنٹ بنایا گیا',
        protectedAccUpdated: 'محفوظ اکاؤنٹ اپ ڈیٹ ہو گیا',
        errorcreatingprotacc: 'محفوظ اکاؤنٹ بنانے میں خرابی۔',
        pleaseSelectOrganizationCreatingAccount:
            "اکاؤنٹ بنانے سے پہلے براہ کرم ایک تنظیم منتخب کریں۔",
        pleaseSelectProjectIdFirst: "براہ کرم پہلے ایک پروجیکٹ منتخب کریں۔",
        norecordareavailbles: 'کوئی ریکارڈ دستیاب نہیں ہے۔',
        downloadlinkmissing: 'ڈاؤن لوڈ کا لنک غائب ہے۔',
        invalidresponse: 'غلط جوابی شکل۔',
        failedFetchReports: "رپورٹس حاصل کرنے میں ناکام۔",
        reportgeneratedsuccc: 'رپورٹ کامیابی کے ساتھ تیار ہو گئی!',
        pleaseSelectRecordProceed: "براہ کرم آگے بڑھنے کے لیے ایک ریکارڈ منتخب کریں!",
        errorOccurredWhileDeletingRecord:
            "ریکارڈ کو حذف کرتے وقت ایک خرابی پیش آگئی۔",
        failedtofetchmeter: 'میٹر کی انوینٹری کی تفصیلات حاصل کرنے میں ناکام۔',
        userStatusupdatesuc: 'صارف کی حیثیت کامیابی کے ساتھ اپ ڈیٹ ہو گئی۔',
        failedtoupdateuserstatus: 'صارف کی حیثیت کو اپ ڈیٹ کرنے میں ناکام۔',
        fileuploadedsucc: 'فائل کامیابی کے ساتھ اپ لوڈ ہو گئی۔',
        failedtouploadfiles: 'فائل اپ لوڈ کرنے میں ناکام۔ براہ کرم help@blufield.net سے رابطہ کریں۔',
        pleasegeneratepreview: 'براہ کرم قسط بنانے سے پہلے پیش نظارہ تیار کریں۔',
        failedtogeneratepdf: 'پی ڈی ایف بنانے میں ناکام۔ براہ کرم دوبارہ کوشش کریں یا help@blufield.net پر ہم سے رابطہ کریں۔',
        installmentupdated: 'قسط کا منصوبہ کامیابی کے ساتھ اپ ڈیٹ ہو گیا!',
        installmentplancretsuc: 'قسط کا منصوبہ کامیابی کے ساتھ بنایا گیا!',
        errorgeneratingpdf: 'پی ڈی ایف بنانے یا قسط کا منصوبہ جمع کرانے میں خرابی!',
        failedtoconnectserver: 'سرور سے منسلک ہونے میں ناکام۔ براہ کرم دوبارہ کوشش کریں۔',
        youcannotpaythefullamount: 'آپ پوری رقم ایک قسط میں ادا نہیں کر سکتے۔ براہ کرم اسے تمام قسطوں میں تقسیم کریں۔',
        eachinstallmentmusthave: 'ہر قسط میں کم از کم کم از کم رقم ہونی چاہیے۔',
        changesavedsuc: 'تبدیلیاں کامیابی سے محفوظ ہو گئیں!',
        plzwentervalidacc: 'براہ کرم ایک درست اکاؤنٹ نمبر درج کریں۔',
        fieldagentassinged: 'فیلڈ ایجنٹ کو تفویض کیا گیا۔',
        NoasssingData: "تفویض کرنے والا کوئی ڈیٹا دستیاب نہیں ہے۔",
        unAssignTaskSuccessMeg: "آپ کی درخواست موصول ہو گئی ہے اور اس پر پس منظر میں کارروائی ہو رہی ہے۔ اس کے مکمل ہونے کے بعد آپ کو مطلع کر دیا جائے گا۔",
        pleaseselect: "پہلے ایک ورک فلو منتخب کریں۔",
        plzenteracommentbeforedel: 'براہ کرم کام کو حذف کرنے سے پہلے ایک تبصرہ درج کریں۔',
        taskdelsuccessfully: 'ٹاسک کامیابی سے حذف ہو گیا۔',
        erroccureduringtask: 'کام کے دوران ایک خرابی پیش آگئی۔',
        failedtoassignbyarea: 'علاقے کے لحاظ سے کام تفویض کرنے میں ناکام۔',
        plzselectactivity: 'براہ کرم ایک سرگرمی منتخب کریں۔',
        noassigneselectedfor: 'تفویض ختم کرنے کے لیے کوئی تفویض منتخب نہیں کیا گیا۔',
        delteallrecord: 'تمام ریکارڈز حذف کر دیے گئے ہیں۔',
        taskprioriyupdated: 'کام کی ترجیح کو اپ ڈیٹ کر دیا گیا۔',
        pdfnotavailable: 'PDF دستیاب نہیں ہے۔',
        datafetchedsuccessfully: 'ڈیٹا کامیابی سے حاصل کیا گیا۔',
        anerroroccuredtaskhistory: 'ٹاسک ہسٹری لانے کے دوران ایک خرابی پیش آگئی۔',
        taskupdatedcussfully: 'ٹاسک کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔',
        erroruploadingfileplztry: 'فائل اپ لوڈ کرنے میں خرابی۔ براہ کرم دوبارہ کوشش کریں یا help@blufield.net پر ہم سے رابطہ کریں۔ ',
        orgismissingnotdrag: 'تنظیم کی شناخت غائب ہے، گھسیٹ نہیں سکتی!',
        nochangwsmadetothe: 'فیلڈ کی قسم میں کوئی تبدیلی نہیں کی گئی۔',
        selectOrgWarning: "پہلے تنظیم کا انتخاب کریں۔",
        pleaseselectdayreport: 'براہ کرم رپورٹ کے لیے دن کا انتخاب کریں۔',
        reportprocesucc: 'رپورٹ پر کامیابی کے ساتھ کارروائی ہوئی!',
        nofileselc: 'کوئی فائل منتخب نہیں کی گئی۔',
        filesizeexceeds: 'فائل کا سائز 5MB سے زیادہ ہے۔',
        invalidfiletypeplimg: 'غلط فائل کی قسم۔ براہ کرم ایک تصویر اپ لوڈ کریں۔',
        invalidfiletypedouc: 'غلط فائل کی قسم۔ براہ کرم ایک دستاویز اپ لوڈ کریں۔',
        unsupportedfile: 'غیر تعاون یافتہ فائل کی قسم۔',
        plzfillallfieldbeforeadd: 'براہ کرم اثاثہ شامل کرنے سے پہلے تمام فیلڈز کو پُر کریں۔',
        assetaddedscucceffuly: 'اثاثہ کامیابی کے ساتھ شامل کر دیا گیا۔',
        fillFieldbeforeAddVehical:
            "گاڑی شامل کرنے سے پہلے براہ کرم تمام فیلڈ پُر کریں۔",
        assetupdatedsuc: 'اثاثہ کامیابی سے اپ ڈیٹ ہو گیا۔',
        vehicalupdatedsuc: 'گاڑی کامیابی کے ساتھ اپ ڈیٹ ہو گئی۔',
        emailidorpass: 'ای میل یا پاس ورڈ غلط ہے۔',
        loginConnectionError:
            'سرور سے رابطہ نہیں ہو سکا۔ اپنا انٹرنیٹ کنکشن چیک کریں اور دوبارہ کوشش کریں۔',
        loginFailed: 'سائن ان نہیں ہو سکا۔ براہ کرم دوبارہ کوشش کریں۔',
        accessdenied: 'رسائی سے انکار!',
        otpverifiedsuc: 'OTP کی کامیابی سے تصدیق ہو گئی۔',
        failedtoverifyotp: 'OTP کی توثیق کرنے میں ناکام۔',
        noworkflowinorg: 'اس تنظیم کے لیے کوئی ورک فلو دستیاب نہیں ہے۔',
        plzuploadpdffileonly: 'براہ کرم صرف پی ڈی ایف یا ویڈیو فائلیں اپ لوڈ کریں۔',
        guidlineuplodsucc: 'گائیڈ لائن کامیابی سے اپ لوڈ ہو گئی۔',
        invalidfiletype: 'غلط فائل کی قسم۔ براہ کرم ایک JPG، PNG، یا GIF اپ لوڈ کریں۔',
        emailnotavailble: 'ای میل دستیاب نہیں ہے۔ براہ کرم یقینی بنائیں کہ آپ کا پروفائل لوڈ ہے۔',
        youcanotmodify: 'آپ موجودہ پاس ورڈ میں ترمیم نہیں کر سکتے جب تک کہ پہلے صاف نہ کر دیا جائے۔',
        youcanowenter: 'اب آپ نیا پاس ورڈ درج کر سکتے ہیں۔',
        passowrdmust: 'پاس ورڈ کم از کم 8 حروف کا ہونا چاہیے، اس میں ایک بڑے حروف، چھوٹے حروف، نمبر، اور خصوصی حرف شامل ہوں',
        profileupdated: 'پروفائل اپ ڈیٹ کر دیا گیا۔',
        failedtofetchemails: 'ای میلز حاصل کرنے میں ناکام',
        enteremailfirst: 'پہلے اپنا ای میل درج کریں، پھر آپ ای میل اطلاعات کو فعال کر سکتے ہیں۔',
        statusupdatedsucc: 'حالت کامیابی کے ساتھ اپ ڈیٹ ہو گئی۔',
        failedtoupdatednotifcation: 'اطلاع کی ترتیب کو اپ ڈیٹ کرنے میں ناکام',
        errorfiledownloaded: 'خرابی: فائل ڈاؤن لوڈ ہو گئی۔',
        fileuploadedaborteddue: 'فائل اپ لوڈ ایک خرابی کی وجہ سے روک دی گئی۔',
        plxselectanoption: 'براہ کرم ایک آپشن منتخب کریں۔',
        pleasefillallmandtoryfield: 'آگے بڑھنے کے لیے براہ کرم تمام لازمی فیلڈز پُر کریں۔',
        uploadcanceled: 'اپ لوڈ منسوخ کر دیا گیا۔',
        nodatavailvle: 'کوئی ڈیٹا دستیاب نہیں ہے۔',
        nofieldavailable: 'کوئی فیلڈز دستیاب نہیں ہیں۔',
        categoriyaddedsucc: 'زمرہ کامیابی کے ساتھ شامل کیا گیا۔',
        plzselectdeltype: 'براہ کرم حذف کرنے کی قسم منتخب کریں۔',
        failedtodelfile: 'فائل کو حذف کرنے میں ناکام۔',
        uploadedtasksheet: 'اپ لوڈ کردہ ٹاسک شیٹ کی فہرست ٹیبل میں دکھائی گئی ہے!',
        nomoredatatoload: 'لوڈ کرنے کے لیے مزید ڈیٹا نہیں ہے۔',
        taskdetailupdatedsuc: 'ٹاسک کی تفصیلات کامیابی کے ساتھ اپ ڈیٹ ہو گئیں!',
        norecordavbforthisacc: 'اس اکاؤنٹ نمبر کے لیے کوئی ریکارڈ دستیاب نہیں، براہ کرم دوسرا اکاؤنٹ نمبر آزمائیں۔',
        userupdatedsuc: 'صارف کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔',
        usercreatedSuc: 'صارف کامیابی کے ساتھ بنایا گیا۔',
        failedtofetchusers: 'صارفین کو لانے میں ناکام۔',
        nofieldabuplodtasksheet: 'کوئی فیلڈ دستیاب نہیں، اضافی فیلڈز حاصل کرنے کے لیے پہلے ٹاسک شیٹ اپ لوڈ کریں۔',
        nomoreuniqueversion: 'مزید منفرد ورژن دستیاب نہیں ہیں۔',
        nomoreversionavailble: 'مزید ورژن دستیاب نہیں ہیں۔',
        createworkflowdiagram: 'ورک فلو بنائیں۔',
        updatepdfnamefirst: 'پہلے پی ڈی ایف کا نام اپ ڈیٹ کریں۔ ',
        pdfnameupdate: 'PDF نام کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔',
        updatereportname: 'پہلے رپورٹ کا نام اپ ڈیٹ کریں۔',
        excelnameupdate: 'ایکسل کا نام کامیابی سے اپ ڈیٹ ہو گیا۔ ',
        inputvlueadded: 'ان پٹ ویلیو شامل!',
        warningthis: 'انتباہ: یہ اختیار پہلے سے ہی ورک فلو میں شامل ہے۔ ہٹانے پر پابندی ہے۔',
        fieldremoved: 'فیلڈ ہٹا دیا گیا۔',
        fieldcloned: 'فیلڈ کلون',
        clonedsuc: 'کامیابی کے ساتھ کلون کیا گیا۔',
        pleaseentername: 'براہ کرم کلون شدہ ورک فلو کے لیے ایک نام درج کریں۔.',
        inputfield: 'ان پٹ فیلڈ خالی نہیں ہو سکتی!',
        warningalready: 'انتباہ: یہ اختیار پہلے سے ہی ورک فلو میں شامل ہے۔ ہٹانے پر پابندی ہے۔ آپ صرف اس اختیار کے نام میں ترمیم کر سکتے ہیں۔',
        validationremoved: 'توثیق ہٹا دی گئی۔ حذف کرنے کے لیے ورک فلو کو اپ ڈیٹ کریں۔',
        validationnotapplicable: 'اس فیلڈ کی قسم کے لیے توثیق کا اطلاق نہیں ہوتا ہے۔',
        updatetheworkflow: 'ان اضافی فیلڈز کو بچانے کے لیے ورک فلو کو اپ ڈیٹ کریں۔',
        failedtoupdatefield: 'فیلڈز کو اپ ڈیٹ کرنے میں ناکام۔ براہ کرم دوبارہ کوشش کریں۔',
        pleaseSelectLeastActivity: "براہ کرم کم از کم ایک سرگرمی منتخب کریں۔",
        failedSubmitReportRequest: "رپورٹ کی درخواست جمع کرانے میں ناکام۔",
        urlnotprovided: 'جواب میں URL فراہم نہیں کیا گیا۔',
        failedtoaddasset: 'اثاثہ شامل کرنے میں ناکام ',
        vehicleaddedsuc: 'گاڑی کامیابی کے ساتھ شامل کر دی گئی۔',
        failToAddVehical: "گاڑی شامل کرنے میں ناکام۔",
        ruleupdatedsuc: 'اصول کامیابی کے ساتھ اپ ڈیٹ ہو گیا!',
        filesdeleted: 'فائل حذف کر دی گئی۔',
        plzselectatleatone: 'براہ کرم تفویض کرنے کے لیے کم از کم ایک کام منتخب کریں۔',
        plzselectedforilfagrntoasing: 'براہ کرم کام تفویض کرنے کے لیے فیلڈ ایجنٹ کا انتخاب کریں۔',
        invalidworkflow: 'غلط ورک فلو۔ براہ کرم دوبارہ کوشش کریں۔',
        softdeletedsucc: 'نرم حذف کامیاب!',
        softdelfailed: 'نرم حذف کرنے میں ناکام!',
        erroduringsoftdel: 'نرم حذف کے دوران خرابی!',
        permamatdelsuc: 'مستقل حذف کامیاب!',
        permantdelfailed: 'مستقل حذف کرنے میں ناکام!',
        errorduringperdel: "مستقل حذف کے دوران خرابی!",
        taskrecallcompletesuc: 'ٹاسک واپسی کامیابی کے ساتھ مکمل ہو گیا!',
        taskrecallfailed: 'ٹاسک یاد کرنے میں ناکام!',
        erroduringtaskrecall: 'ٹاسک یاد کرنے کے دوران خرابی!',
        attachmentismand: 'منسلکہ لازمی ہے!',
        onlypdfimgallowed: 'صرف پی ڈی ایف اور تصویری فائلوں کی اجازت ہے۔',
        workflowmodule: 'ورک فلو ماڈیول موبائل آلات پر دستیاب نہیں ہے۔ جاری رکھنے کے لیے براہ کرم ڈیسک ٹاپ یا ٹیبلیٹ استعمال کریں۔',
        Attachment: 'اٹیچمنٹ ',
        viewattachment: 'اٹیچمنٹ دیکھیں',
        selectedtasknotassinged: 'منتخب کردہ کام تفویض نہیں کیے گئے۔ ',
        Inactive: 'غیر فعال ',
        aresurewantodeleterule: 'کیا آپ واقعی اصول کو حذف کرنا چاہتے ہیں؟',
        Assigning: 'تفویض کرنا ',
        Saving: 'محفوظ کرنا',
        Requesting: 'درخواست کر رہا ہے۔ ',
        enterextendeddate: 'توسیعی تاریخ درج کریں۔',
        targetoutstandingamtbyextdate: 'توسیعی تاریخ کے لحاظ سے بقایا رقم کا ہدف بنائیں',
        Comments: 'تبصرے ',

        aresurewanttodeleterecord: 'کیا آپ واقعی ریکارڈ کو حذف کرنا چاہتے ہیں؟',
        downladreport: 'رپورٹ ڈاؤن لوڈ کریں۔',
        transferto: 'کو منتقل کیا گیا۔',
        nometerdetailfound: 'بار کوڈ کے لیے میٹر کی کوئی تفصیلات نہیں ملی',
        loadingmeterdetail: 'میٹر کی تفصیل لوڈ ہو رہی ہے۔',
        Print: 'پرنٹ ',
        ucantaddmorethan6: `آپ 6 سے زیادہ قسطیں شامل نہیں کر سکتے`,
        Proceed: 'آگے بڑھیں۔ ',
        taskdetails: 'ٹاسک کی تفصیلات',
        viewexistingfile: 'موجودہ فائل دیکھیں',
        nofileuploaded: 'کوئی فائل اپ لوڈ نہیں ہوئی۔',
        nooptionavailable: 'کوئی اختیارات دستیاب نہیں ہیں۔',

        fetchingaccdetails: 'اکاؤنٹ کی تفصیلات حاصل کی جا رہی ہیں۔',
        workflowid: 'ورک فلو ID',
        pdflink: 'پی ڈی ایف لنک',
        selectefieldpreiview: 'پیش نظارہ کے لیے منتخب فیلڈز',
        fieldname: 'فیلڈ کا نام',
        fieldtype: 'فیلڈ کی قسم',
        selectfield: 'فیلڈ منتخب کریں۔',
        selectinputtype: 'ان پٹ کی قسم منتخب کریں۔',
        updateinputype: 'ان پٹ کی قسم کو اپ ڈیٹ کریں۔',
        uploadnewphoto: 'نئی تصویر اپ لوڈ کریں۔',
        Open: 'کھولیں۔ ',
        uploadnewdoc: 'نئی دستاویز اپ لوڈ کریں۔',
        viewpdf: 'پی ڈی ایف دیکھیں',
        dragandroptoupload: 'اپ لوڈ کرنے کے لیے گھسیٹیں اور چھوڑیں۔',
        aresurewantodeletefile: 'کیا واقعی فائل کو حذف کرنا چاہتے ہیں؟',
        generatereport: 'رپورٹ بنائیں ',
        Reject: 'رد کرنا ',
        Approve: 'منظور کرو ',
        loadingmorenotification: 'مزید اطلاعات لوڈ ہو رہی ہیں۔',
        nomorenotification: 'لوڈ کرنے کے لیے مزید اطلاعات نہیں ہیں۔',
        Pending: 'زیر التواء ',
        Task: 'کام ',
        Mandatory: 'لازمی ',
        Fields: 'فیلڈز ',
        Other: 'دیگر ',
        Back: 'پیچھے ',
        thisactivitydoesnothavefield: 'اس سرگرمی میں فیلڈز نہیں ہیں۔',
        subcategory: 'ذیلی زمرہ',
        selectsubcategory: 'ذیلی زمرہ منتخب کریں۔',
        addcategory: 'زمرہ + شامل کریں۔',
        deletetask: 'ٹاسکس کو حذف کریں۔',
        dosoftdeletions: 'نرم حذف کریں۔',
        depermanatdeletions: 'مستقل حذف کریں۔',
        confirmdeletion: 'حذف کرنے کی تصدیق کریں۔',
        areusurewanttoallassinged: 'کیا آپ واقعی تمام تفویض کردہ، پیش رفت اور آن ہولڈ کاموں کو فعال بنانا چاہتے ہیں؟',
        selectlocationmap: 'نقشے پر مقام منتخب کریں۔',
        Loading: 'لوڈ ہو رہا ہے۔',
        nowuserfound: 'کوئی صارف نہیں ملا',
        addfield: 'فیلڈز شامل کریں۔',
        updatefield: 'فیلڈز کو اپ ڈیٹ کریں۔',
        enterworkflowname: 'ورک فلو کا نام درج کریں۔',
        Elements: 'عناصر ',

        Report: 'رپورٹ ',
        editinputvalues: 'ان پٹ ویلیوز میں ترمیم کریں۔',
        addedvalidation: 'توثیق شامل کر دی گئی۔',

        deletefield: 'فیلڈ کو حذف کریں۔',
        deletevalidation: 'توثیق کو حذف کریں۔',
        validationcode: 'توثیق کوڈ',
        novalidationavailable: 'کوئی توثیق دستیاب نہیں ہے۔',
        rusurewanttodeleteworkflow: 'کیا آپ واقعی اس ورک فلو کو حذف کرنا چاہتے ہیں؟',
        noversionavb: 'کوئی ورژن دستیاب نہیں ہے۔',
        noreportdataavb: 'کوئی رپورٹ ڈیٹا دستیاب نہیں ہے۔',
        goback: 'واپس جائیں →',

        aresurewantodeleteemail: 'کیا آپ واقعی اس ای میل کو حذف کرنا چاہتے ہیں؟',
        nofieldagentfound: 'کوئی فیلڈ ایجنٹ نہیں ملا',
        Selected: 'منتخب',
        updatedon: 'کو اپ ڈیٹ کیا گیا۔',
        tariff: 'ٹیرف',
        Office: 'دفتر',
        cancelupload: 'اپ لوڈ منسوخ کریں۔',
        Recall: 'یاد کرنا ',
        notaskavbtounasign: 'غیر تفویض کرنے کے لیے کوئی ٹاسک دستیاب نہیں ہے۔',
        unassigntask: ' ٹاسک کو غیر تفویض کریں۔',
        selectassigntounassign: 'منتخب کردہ کاموں سے غیر تفویض کرنے کے لیے تفویض کردہ افراد کو منتخب کریں۔',
        allassign: 'تمام تفویض کردہ',

        confirmaction: 'کارروائی کی تصدیق کریں۔',
        areusure: 'کیا آپ واقعی اس کام کو حذف کرنا چاہتے ہیں؟ یہ عمل نہیں ہو سکتا',
        totalcount: 'کل شمار',
        Processing: 'پروسیسنگ',
        currenOs: 'موجودہ OS ',
        updatedat: 'پر اپ ڈیٹ کیا گیا۔',
        curros: 'موجودہ بقایا',
        lastupdateddate: 'آخری تازہ کاری کی تاریخ',
        lastupdatedtime: 'آخری تازہ کاری کا وقت',
        assingename: 'تفویض کرنے والے کا نام',
        finisheddate: 'ختم ہونے والی تاریخ',
        fnishedtime: 'فارغ وقت',
        Unsuccessful: 'ناکام ',
        Success: 'کامیابی ',
        fileprocessingcancle: 'فائل پروسیسنگ منسوخ کر دی گئی۔',
        pleaseenteraccnumber: 'براہ کرم اکاؤنٹ نمبر درج کریں۔ ',
        projmissingplzelc: 'پروجیکٹ غائب ہے۔ براہ کرم ایک پروجیکٹ منتخب کریں۔',
        addleastonelementto: 'اگلے صفحہ پر جانے سے پہلے موجودہ صفحہ میں کم از کم ایک عنصر شامل کریں۔',
        checkuremailotp: 'OTP کے لیے اپنا ای میل چیک کریں',
        taskcreatedsuc: 'کام کامیابی کے ساتھ بنائے گئے۔',
        taskunassingedsucc: 'کام کامیابی کے ساتھ غیر تفویض کیا گیا!',
        norecordareavailable: 'کوئی ریکارڈ دستیاب نہیں ہے۔',
        failedtouploadfile: 'فائل اپ لوڈ کرنے میں ناکام',
        failtoupdaterule: 'اصول کو اپ ڈیٹ کرنے میں ناکام',
        startdateerror: 'آغاز کی تاریخ اختتامی تاریخ کے بعد نہیں ہو سکتی',
        anerror: 'اثاثے تفویض کرتے وقت ایک خرابی پیش آگئی.',
        errorsubmiting: 'فارم جمع کرانے میں خرابی۔',
        ruleupdated: 'اصول کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔',
        failupdaterule: 'اصول کو اپ ڈیٹ کرنے میں ناکام',
        plzselectworkflow: 'براہ کرم اصول شامل کرنے سے پہلے ورک فلو کو منتخب کریں۔',

        basicinfo: "بنیادی معلومات",
        changeprofile: "پروفائل تبدیل کریں۔",
        updateRule: 'اپڈیٹ رول',
        newRule: ' نیا اصول',
        assignedAll: 'تمام تفویض',
        notAssignedAll: 'سب کو تفویض نہیں کیا گیا۔',
        LoadingGeo: 'جیو کوڈز لوڈ ہو رہے ہیں۔',
        selectgeocode: 'جیو کوڈ منتخب کریں۔',
        All: 'تمام',
        loadingtyoecodes: 'ٹائپ کوڈز لوڈ ہو رہے ہیں۔',
        selecttypecodes: 'قسم کا کوڈ منتخب کریں۔',
        selectamount: 'رقم کی حد منتخب کریں۔',
        ok: 'ٹھیک ہے',
        addRule: ' قاعدہ شامل کریں۔',
        addproject: 'پروجیکٹ شامل کریں۔',
        departmentname: 'محکمہ کا نام۔',
        projectname: '  پروجیکٹ کا نام',
        adddepartment: 'محکمہ شامل کریں۔',
        seeData: 'ڈیٹا دیکھیں',
        enterrecipt: 'وصول کنندگان کو کوما سے الگ کرکے درج کریں۔',
        enterbcc: 'کوما سے الگ کرکے Bcc درج کریں۔',
        entercc: 'کوما سے الگ کرکے Cc درج کریں۔',
        assignbyrule: 'قواعد کے مطابق تفویض کریں۔',
        searchfieldAgent: 'فیلڈ ایجنٹوں کو تلاش کریں۔',
        loadingtask: 'کام کی تفصیلات لوڈ ہو رہی ہیں۔',
        fieldagentAvgwork: 'فیلڈ ایجنٹ کا اوسط کام کا وقت',
        selectDash: 'ڈیش بورڈ کو منتخب کریں۔',
        selecttask: 'ٹاسک اسٹیٹس کو منتخب کریں۔',
        selectStatus: 'اسٹیٹس کو منتخب کریں۔',
        SelectDateTime: 'تاریخ اور وقت کی حد منتخب کریں۔',
        startdatetime: 'آغاز کی تاریخ اور وقت',
        enddatetime: 'اختتامی تاریخ اور وقت',
        selectDateRange: 'تاریخ کی حد منتخب کریں۔',
        fieldAgentCLock: 'فیلڈ ایجنٹ کلاک ان/آؤٹ',
        selectusertpye: 'صارف کی قسم منتخب کریں۔',
        isClockin: 'ClockIn ہے۔',
        selectvehicle: 'گاڑی منتخب کریں۔',
        vehicalid: 'گاڑی کی شناخت',
        OrganizationId: 'تنظیم کی شناخت',
        inuse: 'استعمال میں',
        id: 'ID',
        selectAsset: 'اثاثہ منتخب کریں۔',
        showLatLog: "لیٹ/لمبی غائب کام دکھائیں۔",
        hidelatlog: "لیٹ/لمبی گمشدہ کاموں کو چھپائیں۔",
        createdatetime: "تاریخکا وقت بنایا گیا۔",
        taskCategory: "ٹاسک کیٹیگری",
        mobileno: "موبائل نمبر",
        discardMessage: 'کیا آپ واقعی چھوڑنا چاہتے ہیں؟ یہ عمل آپ کو محفوظ یا رد کر دے گا۔',
        viewinstallmentmsg: 'قسط کے منصوبے دیکھنے کے لیے اکاؤنٹ نمبر درج کریں۔',
        optionalSelectedfield: 'اختیاری انتخابی فیلڈز',
        emailnotification: 'ای میل اطلاعات',
        recievemeial: 'ٹاسک اپ ڈیٹس اور یاد دہانیوں کے لیے ای میل اطلاعات موصول کریں۔',
        taskmangement: 'ٹاسک مینجمنٹ',
        autoAssignTask: 'خود کار طریقے سے کام تفویض کریں۔',
        autoasigntaskto: 'دستیاب ٹیم کے اراکین کو خودکار طور پر کام تفویض کریں۔ ',
        protectioninWorkflow: 'ورک فلو میں تحفظ',
        preventtaskprotected: 'ایک بار جب کام جاری ہیں ان میں تبدیلیوں کو روکیں۔',
        othersetting: 'دیگر ترتیبات',
        choselang: 'درخواست کے لیے پہلے سے طے شدہ زبان کا انتخاب کریں۔',
        addmeail: 'ای میل شامل کریں۔',
        email: "ای میل",
        notchartYet: 'اس چارٹ کے لیے ابھی تک کوئی ڈیٹا دستیاب نہیں ہے۔',
        priorityLevel: 'ترجیحی سطح',
        entername: "نام درج کریں۔",
        Activities: "سرگرمیاں",
        basicField: " بنیادی فیلڈز",
        recent: "حالیہ",
        selectionfield: "انتخاب کا میدان",
        mediafield: "میڈیا اور خصوصی فیلڈز",
        items: "چیزیں",
        Enable: "فعال کریں۔",
        disable: "غیر فعال",
        comapletedDate: " مکمل ہونے کی تاریخ",
        taskId: "ٹاسک آئی ڈی",
        noproject: "لکوئی پروجیکٹ نہیں۔",
        nodepartment: " کوئی محکمہ نہیں۔",
        noactivity: " لکوئی سرگرمی نہیں۔",
        splaignrule: "خصوصی تفویض کا اصول  ",
        myprofile: " میرا پروفائل ",
        barChart: " بار چارٹ ",
        Piechart: "پائی چارٹ",
        Radarchart: "ریڈار چارٹ",
        Linechart: "لائن چارٹ",
        Areachart: "ایریا چارٹ",
        OrganizationLogo: "تنظیم کا لوگو",
        OrganizationName: "تنظیم کا نام",

        Organizations: "تنظیمیں",
        ReportType: "رپورٹ کی قسم",
        ForInstallmentPlan: "قسط کے منصوبے کے لیے",
        WorkflowNames: "ورک فلو کے نام",
        ReportLink: "رپورٹ کا لنک",
        RequestedAt: "پر درخواست کی۔",
        Noguidelines: "کوئی رہنما خطوط دستیاب نہیں ہیں۔",
        Deleteworkflowmsg:
            "کیا آپ واقعی چھوڑنا چاہتے ہیں؟ یہ عمل آپ کے بنائے گئے ورک فلو ڈھانچے کو حذف کر دے گا۔",
        MandatoryFields: "لازمی فیلڈ",
        NonMandatoryFields: "غیر لازمی فیلڈز",
        BulkUpload: "بلک اپ لوڈ",
        CreateandAssigne: "بنائیں اور تفویض کریں۔",
        AssetName: "اثاثہ کا نام",
        UserId: "یوزر آئی ڈی",
        FieldStaffList: "فیلڈ سٹاف کی فہرست",
        SUBMISSION: "جمع کروانا",
        NOT_COMPLETED: "مکمل نہیں ہوا۔",
        HideCriteria: "معیار چھپائیں۔",
        NewCriteria: "نیا معیار شامل کریں۔",
        ActivityQuestions: "سرگرمی کے سوالات کو منتخب کریں۔",
        FieldQuestion: "فیلڈ سوال منتخب کریں۔",
        Select: "منتخب کریں۔",
        AddChart: "چارٹ شامل کریں۔",
        DeleteDash: "کیا آپ واقعی اس ڈیش بورڈ کو حذف کرنا چاہتے ہیں؟",
        DeleteGraph: "کیا آپ واقعی اس گراف میٹرک کو حذف کرنا چاہتے ہیں؟",
        CreateDash: "ایکٹیویٹی ڈیش بورڈ بنائیں",
        Role: "کردار",
        Activity: "سرگرمی",
        selectWorkflow: "ورک فلو منتخب کریں",
        ActivityName: "سرگرمی کا نام",
        SelectChart: "چارٹ منتخب کریں۔",
        ViewChart: "چارٹ دیکھیں",
        RangeFilter: "تاریخ کی حد کا فلٹر",
        selecrOrg: "براہ کرم ایک تنظیم منتخب کریں۔",
        Page: "صفحہ",
        FieldId: "فیلڈ ایجنٹ کی شناخت",
        FieldAgentName: "فیلڈ ایجنٹ کا نام",
        Action: "ایکشن",
        RemarkReq: "کسٹمر سپورٹ شامل کریں۔",
        adCustSupport: "کسٹمر سپورٹ شامل کریں۔",
        Clone: "کلون",
        SpecialRc: "خاص RC",
        InteractiveRc: "انٹرایکٹو RC",
        Viewinstallment: "قسط دیکھیں",
        createInstallment: "قسط کا منصوبہ بنائیں",
        CustomerId: "کسٹمر آئی ڈی",
        NoOfinstallment: "قسطوں کی تعداد",
        advancepayamt: "پیشگی ادائیگی کی رقم",
        advDate: "پیشگی تاریخ",
        custDetail: "کسٹمر کی تفصیلات",
        instalDetail: "قسط کی تفصیلات",
        firstInstDate: "پہلی قسط کی تاریخ",
        clrPreview: "پیش نظارہ صاف کریں۔",
        prevPlan: "پیش نظارہ پلان",
        submitRc: "کے لیے جمع کروائیں۔ RC",
        AfterAdv: "پیشگی کے بعد بقایا",
        currentOut: "موجودہ بقایا",

        Amount: "رقم ",
        Notes: "نوٹس ",
        Latitude: "عرض بلد ",
        Longitude: "طول البلد ",
        selectFieldAget: "فیلڈ ایجنٹ کو منتخب کریں۔",
        planId: "پلان آئی ڈی",
        planActive: "فعال منصوبہ",
        planCreated: "منصوبہ بنایا",
        outstaningAmt: "بقایا رقم",
        Advamt: "ایڈوانس رقم",
        AdvDate: "پیشگی ادائیگی کی تاریخ",
        firstInsDate: "پہلی قسط کی تاریخ",
        noOfInst: "قسطوں کی تعداد",
        activeInst: "فعال قسطیں",
        DetailId: "تفصیلی شناخت ",
        PaymentId: "ادائیگی کی شناخت",
        PayAmt: "ادائیگی کی رقم",
        payDate: "ادائیگی کی تاریخ",
        Status: "حیثیت ",
        PayPrev: "ادائیگی کا پیش نظارہ",
        OutAfteAdv: "پیشگی کے بعد بقایا",
        CurrentOut: "موجودہ بقایا",
        NoinstAvlble: "کوئی قسط دستیاب نہیں۔",
        title: "Blufield یوٹیلیٹیز ٹاسک مینجمنٹ سلوشنز",
        userEmail: "صارف نام/ای میل پتہ",
        password: "پاس ورڈ ",
        remember: "مجھے یاد رکھنا",
        forgetpass: "پاس ورڈ بھول جائیں۔",
        Login: "لاگ ان ",

        pressEnter: "متعدد اکاؤنٹ نمبرز شامل کرنے کے لیے Enter دبائیں۔",
        typeEnter: "ایک نمبر ٹائپ کریں اور انٹر دبائیں۔",

        payDetail: "ادائیگی کی تفصیلات",
        cretDate: "تخلیق کی تاریخ",
        inactiveplane: "غیر فعال قسطوں کے منصوبے",
        instplanDetail: "قسط کے منصوبے کی تفصیلات",
        loogoutMsg: "کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟",
        Logout: "لاگ آؤٹ",
        support: "کسٹمر سپورٹ",
        supporttooltip: "سپورٹ سسٹم  RC",
        installment: " قسط کا منصوبہ",
        downloadPdf: "پی ڈی ایف ڈاؤن لوڈ کریں۔",
        noDatavb: "کوئی ڈیٹا دستیاب نہیں ہے۔",
        viewValidation: "توثیق دیکھیں",
        refresh: "ٹیبل ریفریش کریں۔",
        discard: "رد کر دیں۔",
        Confirm: "تصدیق کریں۔",
        datefilterforchart: " مکمل کام کے لیے تاریخ کا فلٹر   ",
        updatetaskdetail: "ٹاسک کی تفصیلات کو اپ ڈیٹ کریں۔  ",
        completedTaskCount: "مکمل ٹاسک کاؤنٹ  ",
        taskpriority: "کام کی ترجیح  ",
        taskstatus: "ٹاسک اسٹیٹس ",
        usercount: "صارف شمار",
        listvbiew: "ٹاسک لسٹ ویو  ",
        previous: "پچھلا",
        next: "اگلا",
        date: "تاریخ",
        from: "سے",
        to: "کو",
        apply: "لگائیں",
        unassignn: "إلغاء التعيين",
        dashboard: "لوحة القيادة",
        dashboardtolltip: "لوحة القيادة، عرض وإدارة نظرة عامة على لوحة القيادة",
        usertooltip: "المستخدمون، إدارة حسابات المستخدمين والأدوار",
        setting: "الإعدادات",
        asset: "إدارة الأصول",
        assettooltip: "الأصول، عرض وإدارة الأصول الخاصة بك",
        config: "التكوين",
        configtooltip:
            "التكوين، إدارة قواعد التعيين، القواعد المخصصة وقواعد الإتمام",
        task: "إدارة المهام",
        tasktooltip: "إدارة المهام، إدارة مهامك وتعييناتك، والحذف",
        acchistory: "تاريخ الحساب",
        accReportsCenter: "اکاؤنٹس اور رپورٹس سینٹر",
        historytooltip: "تاريخ الحساب، عرض تاريخ المهام المكتملة",
        workflowe: "سير العمل",
        workflowtooltip: "سير العمل، إدارة سير العمل الخاص بك، الإرشادات",
        worklog: "سجل العمل",
        worklogtooltip:
            "سجل العمل، عرض وإدارة سجلات العمل الخاصة بك، تصدير تقرير Excel، تصدير PDF",
        security: "الأمان",
        securitytooltip: "الأمان، إدارة إعدادات الأمان",

        reportooltip: "التقارير، طلب تقرير، التحقق من حالة التقارير",
        roleManagement: "رول کی بنیاد پر انتظام",
        roleManagementtooltip: "رول اور اجازتیں منظم کریں",
        createRole: "رول بنائیں",
        updateRole: "رول اپ ڈیٹ کریں",
        deleteRole: "رول حذف کریں",
        roleName: "رول کا نام",
        confirmDeleteRole: "کیا آپ واقعی اس رول کو حذف کرنا چاہتے ہیں؟",
        noRolesFound: "کوئی رول نہیں ملا",
        org: "المنظمة",

        orgtooltip: "المنظمة، إدارة المنظمة",
        stock: "إدارة المخزون",
        stocktoooltip: "إدارة المخزون، تحديث تفاصيل المخزون، تنزيل التقرير",
        addUser: "إضافة مستخدم",
        searchusername: "البحث بواسطة اسم المستخدم...",
        searchareacode: "البحث بواسطة رمز المنطقة...",
        userType: "نوع المستخدم",
        user: "مستخدم",
        edit: "تعديل",
        userlist: "إدارة المستخدمين",
        userdetail: "تفاصيل المستخدم",
        previllage: "الامتيازات",
        cancle: "إلغاء",
        updateuser: "تحديث المستخدم",
        add: "إضافة مستخدم",
        username: "إضافة مستخدم",

        selectOrg: "اختيار المنظمة",
        areCode: "رمز المنطقة",
        addeditActivity: "إضافة/تعديل النشاط",
        addnewlabel: "إضافة/تعديل التكوين",
        addEdituser: "صارف کو شامل/ترمیم کریں۔",
        canasset: "يمكن الوصول إلى إدارة الأصول",
        uservisibility: "رؤية المستخدم",
        modifyguidline: "تعديل الإرشادات",
        createDashboar: "إنشاء لوحة القيادة",
        addeditleader: "إضافة/تعديل لوحة القيادة",
        canTaskManage: "يمكن الوصول إلى إدارة المهام",
        canAddEditProtectedAccount: "يمكن إضافة/تعديل الحساب المحمي",
        canAddEditInventory: "يمكن إضافة/تعديل إدارة المخزون",
        general: "عام",
        save: "حفظ التغييرات",
        langSetting: "إعدادات اللغة ",
        colormode: "وضع اللون ",
        light: "فاتح",
        dark: "داكن",
        highcontrast: "تباين عالي",
        lang: "اللغة",
        toursetting: "إعدادات الجولة",
        stoptour: "إيقاف الجولة",
        starttour: "بدء الجولة",
        custommarker: "علامة مخصصة",
        all: "الكل",
        assigned: "مخصص",
        active: "فعال ",
        progress: "قيد التقدم",
        completed: "مكتمل",
        onhold: "معلق",
        //ASSET
        vehical: "مركبة",
        Inventory: "المخزون",
        exportreport: "تصدير التقرير",
        addVehical: "إضافة مركبة جديدة",
        addAsset: "إضافة أصل جديد",
        search: "بحث",
        vehicalType: "نوع المركبة",
        vehicalAssign: "مخصص المركبة",
        searchbyId: "البحث بواسطة المعرف...",
        assetType: "نوع الأصل",
        assetAssign: "مخصص الأصل",
        addnewasset: "إضافة أصل جديد",
        assetId: "اثاثہ کی شناخت",
        agentAssigned: "ایجنٹ تفویض",
        assetStatus: "اثاثہ کی حیثیت",
        updateAsset: "تحديث الأصل",
        Update: "تحديث",
        updateVehical: "تحديث المركبة",
        //CONFIGURATION
        complitionrule: "قواعد الإتمام",
        assignment: "قواعد التعيين",
        customerule: "المتغيرات المخصصة",
        rulename: "اسم القاعدة",
        assignTo: "التعيين إلى",
        activedeactive: "نشط / غير نشط",
        criteria: "المعايير",
        submit: "إرسال",
        update: "اپ ڈیٹ کریں۔",
        norule: "لا توجد قواعد لتحميلها",
        icon: "أيقونة",
        createrule: "إنشاء قاعدة جديدة",
        addNewRule: "نیا اصول شامل کریں۔",
        //TASKMANAGE
        multiSelect: "تحديد متعدد",
        smartAssign: "التعيين الذكي",
        FieldStaff: "فیلڈ سٹاف",
        Location: "مقام",
        MapStatus: "نقشہ کی حیثیت",
        fieldAgent: "وكيل ميداني",
        createNewTask: "إنشاء مهمة جديدة",
        importCSV: "رفع المهمة",
        mapview: "عرض الخريطة",
        createTask: "إنشاء مهمة جديدة",
        download: "تنزيل",
        deleteAllRecord: "حذف جميع السجلات",
        assign: "تعيين",
        reassign: "إعادة تعيين",
        alert: "إرسال تنبيه",
        delete: "حذف",
        priority: "الأولوية",
        status: "الحالة",
        searchbycode: "البحث بواسطة رمز المنطقة..",
        selectAssign: "اختيار المعين",
        downloadtask: "تنزيل تقرير المهمة",
        seectallactivty: "تحديد جميع الأنشطة",
        selectpartcular: "اختيار نشاط معين",
        selectMsg: "يرجى تحديد نشاط للمتابعة.",
        createnewtask: "إنشاء مهمة جديدة",
        cancel: "إلغاء",
        create: "إنشاء",
        DragDetail: "اسحب وأفلت ملف CSV الذي يحتوي على جميع تفاصيل المهام",
        sizeMsg: "الحد الأقصى لحجم الملف: 15 ميجابايت",
        import: "استيراد CSV",
        uploadfile: "رفع ورقة المهام",
        uploadby: "تم الرفع بواسطة",
        uploaddate: "تاريخ الرفع",
        uploadtime: "وقت الرفع (24 ساعة)",
        taskdetail: "تفاصيل المهمة",
        taskhistory: "تاريخ المهمة",
        nohistory: "لا توجد تاريخ للمهمة.",
        more: "جاري تحميل المزيد من تاريخ المهام...",
        enteraccno: "أدخل رقم الحساب",
        reset: "إعادة تعيين",
        submitting: "جاري الإرسال..",
        accDetail: "تفاصيل الحساب",
        accnumber: "رقم الحساب",
        area: "المنطقة",
        areacode: "رمز المنطقة",
        latitude: "خط العرض",
        longitude: "خط الطول",
        importdb: "استيراد قاعدة البيانات الرئيسية",
        exportData: "تصدير التقرير",
        downloading: "جاري التنزيل...",
        viewGuideline: "عرض الإرشادات",
        createWorkflow: "إنشاء سير عمل جديد",
        guidline: "الإرشادات",
        noworkflow: "لا توجد سير عمل متاحة",
        Scheduleemail: "جدولة تقرير عبر البريد الإلكتروني",
        export: "تصدير التقرير",
        pdf: "تصدير PDF",
        todo: "قيد التنفيذ",
        loading: "جاري تحميل المزيد من سجل العمل...",
        nomore: "لا توجد المزيد من سجلات العمل لتحميلها",
        name: "حساب محمي",
        createacc: "إنشاء حساب جديد",
        editacc: "تعديل الحساب المحمي",
        createproacc: "إنشاء حساب محمي",
        permanent: "حماية دائمة",
        protectionValid: "تحفظ درست ہے۔",
        createdBy: "کی طرف سے پیدا کیا",
        accProtection: "حماية الحساب لجميع الأنشطة",
        accno: "رقم الحساب",
        remark: "ملاحظات",
        enterremark: "أدخل ملاحظاتك هنا",
        updatemeterDEtail: "تحديث تفاصيل العداد",
        downloadsheet: "تنزيل الورقة",
        uploadinventory: "رفع ورقة المخزون",
        reportType: "نوع التقرير",

        form: "طلب تقرير",
        uploadSheet: "رفع الورقة",
        startDate: "تاريخ البدء",
        endDate: "تاريخ الانتهاء",
        request: "طلب",

        orglist: "قائمة المنظمات",
        createOrg: "إنشاء منظمة",
        noOrg: "لا توجد بيانات للمنظمة.",
        rows: "الصفوف لكل صفحة",
        orgname: "اسم المنظمة",
        img: "رفع الشعار",

        creating: "جاري الإنشاء...",
        updateOrg: "تحديث المنظمة",

        Updating: "جاري التحديث...",
        nolog: "لا يوجد شعار",
        number: "لنہیں",
        geoCodes: "منتخب جیو کوڈز",
        typeCodes: "منتخب قسم کے کوڈز",
        amountRange: "منتخب کردہ رقم کی حد",
        assignAll: "سب کو تفویض کریں۔",
        default: "طے شدہ",
        assingTask: "کام تفویض کریں۔",
        //dashbord
        userdashboard: "لوحة القيادة للمستخدم",
        activitydashboard: "لوحة القيادة للنشاط",
        admin: "مسؤول",
        office_user: "المستخدمون في المكتب",
        field_agent: "وكلاء ميدانيون",
        dashboardName: "اسم لوحة القيادة",
        addnewDashboard: "إضافة لوحة قيادة جديدة",
        chartMessage: "حدد لوحة القيادة لعرض الرسوم البيانية",
        deletDashbord: "حذف لوحة القيادة",
        //notifucation
        notification: "إشعار",
        allnotification: "جميع الإشعارات",
        profile: "الملف الشخصي",
        select: "اختيار النشاط",
        selecteOrgName: "اختيار اسم المنظمة",
        selectsubactivty: "اختيار النشاط الفرعي",

        emailreport: "جدولة تقرير عبر البريد الإلكتروني",
        selectactivity: "اختيار النشاط:",
        recipients: "المستلمون",
        bcc: "نسخة مخفية",
        cc: "نسخة",
        sendreport: "إرسال التقرير المجدول",
        senddashboard: "إرسال لوحة القيادة:",
        shedulesend: "جدولة الإرسال:",
        daily: "يومي",
        weekly: "أسبوعي",
        monthly: "شهري",

        send: "إرسال",
        reportbtn: "طلب تقرير",
        report: "التقارير",

        stockmanag: "إدارة المخزون",
        fromdate: "من تاريخ",
        todate: "إلى تاريخ",
        metercode: "رمز بار العداد",
        location: "إلى الموقع",
        filter: "تطبيق الفلاتر",
        addbtn: "إضافة",
        visitTime: "وزٹ ٹائم",
        visitDate: " وزٹ کی تاریخ ",
        nopdfavb: "کوئی PDF دستیاب نہیں ہے۔ ",

        // login
        Utilities: "افادیت اور",
        TasksManagementSolutions: "ٹاسک مینجمنٹ کے حل",
        UsernameEmailAddress: "صارف نام / ای میل ایڈریس",
        RememberMe: "مجھے یاد رکھنا",
        ForgotPassword: "اپنا پاس ورڈ بھول گئے؟",
        assetBarCode: "اثاثہ بارکوڈ",
        dragAndDropDocuments: "دستاویزات کو گھسیٹیں اور چھوڑیں۔",
        viewDocuments: "دستاویز دیکھیں",
        uploadedDocument: "اپ لوڈ کردہ دستاویز",
        maxFileSize5MB: "زیادہ سے زیادہ فائل کا سائز: 5MB",
        browse: "براؤز کریں۔",
        description: "تفصیل",
        kilometer: "کلومیٹر",
        noAccountDetialsAvailable: "اکاؤنٹ کی کوئی تفصیلات دستیاب نہیں ہیں۔",
        enterAccSubmitViewDetails:
            "تفصیلات دیکھنے کے لیے اکاؤنٹ نمبر درج کریں اور سبمٹ کریں۔",
        uploading: "اپ لوڈ ہو رہا ہے۔",
        upload: "اپ لوڈ کریں۔",
        addOrganization: "تنظیم شامل کریں۔",
        addDepartment: "محکمہ شامل کریں۔",
        uploadOrganizationLogo: "تنظیم کا لوگو اپ لوڈ کریں۔",
        successMessage:
            "براہ مہربانی انتظار کریں! فائل اپ لوڈ ہو رہی ہے۔ اس میں کچھ وقت لگ سکتا ہے، اور کامیابی سے اپ لوڈ ہونے کے بعد، آپ کو کامیابی کا پیغام موصول ہوگا۔",
        fullName: "پورا نام",
        department: "محکمہ",
        project: "پروجیکٹ",
        profileImage: "پروفائل امیج",
        vehicleId: "گاڑی کی شناخت",
        vehicleKM: "گاڑی (KM)",
        vehicleAssinged: "گاڑی تفویض کی گئی۔",
        editPrivileges: "مراعات میں ترمیم کریں۔",
        source: "ماخذ",
        thecustomcodewarningmessage:
            "حسب ضرورت مارکر رنگ شامل نہیں کیا گیا، نیچے سے منتخب کریں!!",
        selectWorkflowFirst: "پہلے ورک فلو کو منتخب کریں۔",
        makerColor: "مارکر رنگ کامیابی سے محفوظ ہو گئے!",
        failedtoSaveMakerColor: "مارکر کا رنگ محفوظ کرنے میں ناکام!",
        permanentProtection: "مستقل تحفظ کی آخری تاریخ نہیں ہوگی۔",
        noRecordAvailable: "کوئی ریکارڈ دستیاب نہیں۔",
        reportGenerating: "رپورٹ تیار ہو رہی ہے...",
        mediumPriority: "درمیانی ترجیح",
        highPriority: "اعلیٰ ترجیح",
        lowPriority: "کم ترجیح",

        accountProtection: "اکاؤنٹ کا تحفظ",
        clockIn: "گھڑی میں",
        clockOut: "گھڑی باہر",
        showAsFilter: "فلٹر کے طور پر دکھائیں",
        English: "انگریزی",
        Urdu: "اردو",
        Arabic: "عربی",
        History: "تاریخ",
        Heading: "سرخی",
        Name: "نام",
        Email: "ای میل",
        Phone: "فون",
        Address: "پتہ",
        DatePicker: "تاریخ چننے والا",
        TakePhoto: "تصویر لیں",
        MultipleImages: "متعدد تصاویر",
        Signature: "دستخط",
        RadioButton: "ریڈیو بٹن",
        Checkbox: "چیک باکس",
        Dropdown: "ڈراپ ڈاؤن",
        Number: "نمبر",
        Time: "وقت",
        LongText: "لمبا متن",
        Barcode: "بارکوڈ",
        wfElTooltipHeading: "سرخی شامل کرنے کے لیے استعمال کریں۔",
        wfElTooltipName: "فیلڈ کے لیے نام درج کریں۔",
        wfElTooltipEmail: "درست ای میل پتہ درج کریں۔",
        wfElTooltipPhone: "فون نمبر درج کریں۔",
        wfElTooltipAddress: "پتہ درج کریں۔",
        wfElTooltipDate: "کیلنڈر سے تاریخ منتخب کریں۔",
        wfElTooltipPhoto: "تصویر اپ لوڈ کریں۔",
        wfElTooltipMultiImage: "متعدد تصاویر اپ لوڈ کریں۔",
        wfElTooltipSignature: "دستخط شامل کریں۔",
        wfElTooltipRadio: "متعدد میں سے ایک آپشن منتخب کریں۔",
        wfElTooltipCheckbox: "متعلقہ صورت میں متعدد آپشن منتخب کریں۔",
        wfElTooltipDropdown: "ڈراپ ڈاؤن فہرست سے آپشن منتخب کریں۔",
        wfElTooltipNumber: "عددی قدر درج کریں۔",
        wfElTooltipTime: "مخصوص وقت منتخب کریں۔",
        wfElTooltipLongText: "تفصیلی متن یا تفاسیر درج کریں۔",
        wfElTooltipBarcode: "ان پٹ کے لیے بارکوڈ اسکین کریں۔",
        wfElTooltipOcr: "بصری حروف کی شناخت (OCR)۔",
        wfElTooltipGps: "گلوبل پوزیشننگ سسٹم۔",
        workflowModalPreviewOptionsEmpty:
            "اپنے فارم بلڈر میں اختیارات شامل کریں تاکہ وہ یہاں نظر آئیں۔",
        NotificationSound: "اطلاع کی آواز",
        TestSound: "ٹیسٹ ساؤنڈ",
        Configurations: "کنفیگریشنز",
        TermsAndConditions: "شرائط و ضوابط",
        DragDropTermsConditionFile: "شرائط و ضوابط کی فائل کو گھسیٹ کر چھوڑیں۔",
        PrivacyAcceptance: "رازداری کی قبولیت",
        DragDropPrivacyAcceptanceFile:
            "رازداری کی قبولیت فائل کو گھسیٹیں اور چھوڑیں۔",
        TermsandConditionPdf: "شرائط و ضوابط.pdf",
        view: "دیکھیں",
        NoReportDataavailble: "کوئی رپورٹ ڈیٹا دستیاب نہیں ہے۔",
        UnexpectedResponseFormat: "غیر متوقع جوابی شکل۔ براہ کرم دوبارہ کوشش کریں۔",
        chooseFile: "فائل کا انتخاب کریں۔",
        noFile: "کوئی فائل منتخب نہیں کی گئی۔",
        PasswordRequired: "پاس ورڈ درکار ہے۔",
        PasswordMustBeAtLeast8Characters: "پاس ورڈ کم از کم 8 حروف کا ہونا چاہیے۔",
        IncludeDeletedRecords: "حذف شدہ ریکارڈز شامل کریں۔",

        pleaseFillAllFieldsBeforeSaving:
            "براہ کرم محفوظ کرنے سے پہلے تمام فیلڈ پُر کریں۔",
        ruleCreatedSuccessfully: "اصول کامیابی کے ساتھ بنایا گیا۔",
        pleaseSelectFromDateToDate:
            "براہ کرم تاریخ سے اور تاریخ تک دونوں کو منتخب کریں۔",

        instalmentPlanNotExisting:
            "دیئے گئے اکاؤنٹ نمبر کے لیے قسط کا منصوبہ موجود نہیں ہے۔",
        remarksError: "ریمارکس فیلڈ درکار ہے۔",
        previewPlanError: "ہمیں ایک غیر متوقع خرابی کا سامنا کرنا پڑا۔",

        meterBarCode: "میٹر بار کوڈ",
        components: "اجزاء",
        meterType: "میٹر کی قسم",
        manufacturingYear: "مینوفیکچرنگ سال",
        meterMake: "میٹر بنائیں",
        activationDate: "ایکٹیویشن کی تاریخ",
        batchNo: "بیچ نمبر",
        installationStatus: "تنصیب کی حیثیت",
        createBy: "کی طرف سے پیدا کیا",
        createdAt: "پر پیدا کیا",
        simNo: "سم نمبر",
        ipAddress: "آئی پی ایڈریس",
        iccid: "iccid",
        apn: "apn",
        op: "op",
        balance: "توازن",
        simDetailUpdatedAt: "سم کی تفصیلات کو اپ ڈیٹ کیا گیا۔",
        transferredFrom: "سے منتقل",
        transferredTo: "کو منتقل کر دیا گیا۔",
        DragYourElementsToSecondPageFromLeftPanel: "اپنے عناصر کو بائیں پینل سے دوسرے صفحہ پر گھسیٹیں۔",
        Deactive: "غیر فعال",
        Yes: "جی ہاں",
        No: "نہیں",
        WhatDoYouWantExistingAccounts: "آپ موجودہ اکاؤنٹس کے ساتھ کیا کرنا چاہتے ہیں؟",
        updateAlreadyExistingAccountEntries: "پہلے سے موجود اکاؤنٹ اندراجات کو اپ ڈیٹ کریں؟",
        createNewAccountEntries: "نئے اکاؤنٹ اندراجات بنائیں؟",
        customerDetails: "قسط کی تخلیق کی تفصیل",
        created_By: "کی طرف سے پیدا کیا",
        accountNo: "اکاؤنٹ نمبر",
        civilId: "کسٹمر آئی ڈی",
        phoneNo: "فون نمبر",
        comment: "تبصرہ",

        // Urdu overrides for map task UI, dates, and stock (later entries win over mixed duplicates above)
        fromdate: "تاریخ سے",
        todate: "تاریخ تک",
        protectionValid: "تحفظ کی میعاد تک",
        stockmanag: "اسٹاک کا انتظام",
        metercode: "میٹر کا بارکوڈ",
        meterBarCode: "میٹر کا بارکوڈ",
        meterMake: "میٹر بنانے والی کمپنی",
        nopdfavb: "PDF دستیاب نہیں ہے۔",
        assign: "تفویض کریں",
        reassign: "دوبارہ تفویض کریں",
        unassignn: "غیر تفویض کریں",
        delete: "حذف کریں",
        exportBtn: "ایکسپورٹ",
        importBtn: "امپورٹ",
        addTaskBtn: "ٹاسک شامل کریں",
        attachProof: "ثبوت منسلک کریں (PDF/تصویر)",
        exportData: "ایکسپورٹ",
        importdb: "ماسٹر ڈیٹابیس امپورٹ",
        activityAnalytics: "سرگرمی تجزیات",
        analyticsStatusLabel: "حیثیت",
        chartSelectFiltersHint:
            "چارٹ دیکھنے کے لیے سرگرمی، حیثیت اور تاریخیں منتخب کریں",
        chartLoading: "لوڈ ہو رہا ہے...",
        taskActions: "ٹاسک کارروائیاں",
        selectedLocation: "منتخب مقام",
        drawnArea: "کھینچا ہوا علاقہ",
        clearSelection: "صاف کریں",
        clickMarkerForLocationDetails:
            "مقام کی تفصیلات دیکھنے کے لیے نقشے پر نشان پر کلک کریں",
        taskDetailsSection: "ٹاسک کی تفصیلات",
        loadingTaskDetails: "ٹاسک کی تفصیلات لوڈ ہو رہی ہیں...",
        clickMarkerLoadTaskDetails:
            "ٹاسک کی تفصیلات لوڈ کرنے کے لیے نشان پر کلک کریں۔",
        taskStatusSection: "ٹاسک کی حیثیت",
        availableAgents: "دستیاب ایجنٹس",
        searchFieldAgentsPlaceholder: "فیلڈ ایجنٹس تلاش کریں...",
        noAgentsMatchSearch: "آپ کی تلاش سے کوئی ایجنٹ میل نہیں کھاتا",
        noAgentsAvailable: "کوئی ایجنٹ دستیاب نہیں",
        loadingAgentsLabel: "ایجنٹس لوڈ ہو رہے ہیں...",
        statusActiveLabel: "فعال",
        statusInProgressLabel: "جاری",
        statusCompletedLabel: "مکمل",
        statusAssignedLabel: "تفویض شدہ",
        statusOnHoldLabel: "موقوف",
        unassignedLabel: "غیر تفویض",
        taskIdLabel: "ٹاسک آئی ڈی",
        assigneeLabel: "تفویض شدہ فرد",
        completedCountSuffix: "مکمل",
        tasksInDrawnAreaTitle: "کھینچے گئے علاقے میں ٹاسکس",
        tasksListTitle: "ٹاسکس",
        centerApproxLabel: "مرکز (تقریبی)",
        latLongUpperLabel: "عرض بلد / طول بلد",
        agentUpperLabel: "ایجنٹ",
        activeTasksUpperLabel: "فعال ٹاسکس",
        taskWord: "ٹاسک",
        tasksWord: "ٹاسکس",
        assignTaskCountVerb: "تفویض",
        taskSingular: "ٹاسک",
        tasksPlural: "ٹاسکس",
        onlineLabel: "آن لائن",
        offlineLabel: "آف لائن",
        showOnlineAgentsTitle: "آن لائن ایجنٹس دکھائیں",
        showOfflineAgentsTitle: "آف لائن ایجنٹس دکھائیں",
        onlyActiveTasksAssignableTitle:
            "صرف فعال ٹاسکس تفویض کیے جا سکتے ہیں",
        consNameEnglish: "صارف کا نام (انگریزی)",
        consNameArabic: "صارف کا نام (عربی)",
        meterNoLabel: "میٹر نمبر",
        consumerTypeLabel: "صارف کی قسم",
        phoneLabel: "فون",
        lastReadTypeLabel: "آخری ریڈنگ کی قسم",
        lastReadingLabel: "آخری ریڈنگ",
        lastReadingDateLabel: "آخری ریڈنگ کی تاریخ",
        averageLabel: "اوسط",
        remark: "نوٹس",
        enterremark: "یہاں اپنے نوٹس درج کریں",
        areacode: "علاقہ کوڈ",
        area: "علاقہ",
        latitude: "عرض البلد",
        longitude: "طول البلد",
        pleaseSelectFromDateToDate:
            'براہ کرم "تاریخ سے" اور "تاریخ تک" دونوں منتخب کریں۔',
        all: "سب",
        allFieldAgents: "تمام فیلڈ ایجنٹس",

        employee: 'ملازم', // employed id added by harshit vachhani
        subContract: 'ذیلی معاہدہ', // subContract added by harshit vachhani
    },
};

export default translations;
